export interface MACompInfo {
  codeMain: string
  codeSub: string
  MAnum: string
  pref: string
  MAName: string
  areaCode: string
  square: string
  head4digits: string
}

const MACompList: MACompInfo[] = [
  {
    codeMain: '1',
    codeSub: '',
    MAnum: '1',
    pref: '北海道',
    MAName: '札幌',
    areaCode: '11',
    square: '861-622',
    head4digits: '0112',
  },
  {
    codeMain: '2',
    codeSub: '',
    MAnum: '2',
    pref: '北海道',
    MAName: '千歳',
    areaCode: '123',
    square: '848-634',
    head4digits: '0123',
  },
  {
    codeMain: '3',
    codeSub: '',
    MAnum: '3',
    pref: '北海道',
    MAName: '夕張',
    areaCode: '123',
    square: '861-647',
    head4digits: '0123',
  },
  {
    codeMain: '4',
    codeSub: '2',
    MAnum: '4',
    pref: '北海道',
    MAName: '栗山',
    areaCode: '123',
    square: '861-639',
    head4digits: '0123',
  },
  {
    codeMain: '6',
    codeSub: '',
    MAnum: '5',
    pref: '北海道',
    MAName: '芦別',
    areaCode: '124',
    square: '887-655',
    head4digits: '0124',
  },
  {
    codeMain: '7',
    codeSub: '',
    MAnum: '6',
    pref: '北海道',
    MAName: '滝川',
    areaCode: '125',
    square: '889-644',
    head4digits: '0125',
  },
  {
    codeMain: '8',
    codeSub: '2',
    MAnum: '7',
    pref: '北海道',
    MAName: '岩見沢',
    areaCode: '126',
    square: '869-638',
    head4digits: '0126',
  },
  {
    codeMain: '10',
    codeSub: '',
    MAnum: '8',
    pref: '北海道',
    MAName: '岩見沢',
    areaCode: '1267',
    square: '869-638',
    head4digits: '0126',
  },
  {
    codeMain: '11',
    codeSub: '2',
    MAnum: '9',
    pref: '北海道',
    MAName: '石狩',
    areaCode: '133',
    square: '872-621',
    head4digits: '0133',
  },
  {
    codeMain: '12',
    codeSub: '',
    MAnum: '10',
    pref: '北海道',
    MAName: '当別',
    areaCode: '133',
    square: '870-628',
    head4digits: '0133',
  },
  {
    codeMain: '15',
    codeSub: '',
    MAnum: '11',
    pref: '北海道',
    MAName: '小樽',
    areaCode: '134',
    square: '869-607',
    head4digits: '0134',
  },
  {
    codeMain: '16',
    codeSub: '',
    MAnum: '12',
    pref: '北海道',
    MAName: '余市',
    areaCode: '135',
    square: '869-599',
    head4digits: '0135',
  },
  {
    codeMain: '17',
    codeSub: '',
    MAnum: '13',
    pref: '北海道',
    MAName: '岩内',
    areaCode: '135',
    square: '857-587',
    head4digits: '0135',
  },
  {
    codeMain: '18',
    codeSub: '',
    MAnum: '14',
    pref: '北海道',
    MAName: '倶知安',
    areaCode: '136',
    square: '852-597',
    head4digits: '0136',
  },
  {
    codeMain: '19',
    codeSub: '',
    MAnum: '15',
    pref: '北海道',
    MAName: '寿都',
    areaCode: '136',
    square: '847-576',
    head4digits: '0136',
  },
  {
    codeMain: '20',
    codeSub: '',
    MAnum: '16',
    pref: '北海道',
    MAName: '鹿部',
    areaCode: '1372',
    square: '804-601',
    head4digits: '0137',
  },
  {
    codeMain: '21',
    codeSub: '',
    MAnum: '17',
    pref: '北海道',
    MAName: '森',
    areaCode: '1374',
    square: '809-591',
    head4digits: '0137',
  },
  {
    codeMain: '22',
    codeSub: '',
    MAnum: '18',
    pref: '北海道',
    MAName: '八雲',
    areaCode: '137',
    square: '817-578',
    head4digits: '0137',
  },
  {
    codeMain: '23',
    codeSub: '',
    MAnum: '19',
    pref: '北海道',
    MAName: '八雲',
    areaCode: '1377',
    square: '817-578',
    head4digits: '0137',
  },
  {
    codeMain: '24',
    codeSub: '',
    MAnum: '20',
    pref: '北海道',
    MAName: '今金',
    areaCode: '137',
    square: '826-567',
    head4digits: '0137',
  },
  {
    codeMain: '25',
    codeSub: '',
    MAnum: '21',
    pref: '北海道',
    MAName: '函館',
    areaCode: '138',
    square: '790-597',
    head4digits: '0138',
  },
  {
    codeMain: '26',
    codeSub: '',
    MAnum: '24',
    pref: '北海道',
    MAName: '木古内',
    areaCode: '1392',
    square: '785-585',
    head4digits: '0139',
  },
  {
    codeMain: '27',
    codeSub: '',
    MAnum: '22',
    pref: '北海道',
    MAName: '松前',
    areaCode: '139',
    square: '771-571',
    head4digits: '0139',
  },
  {
    codeMain: '28',
    codeSub: '2',
    MAnum: '23',
    pref: '北海道',
    MAName: '江差',
    areaCode: '139',
    square: '795-572',
    head4digits: '0139',
  },
  {
    codeMain: '30',
    codeSub: '',
    MAnum: '25',
    pref: '北海道',
    MAName: '奥尻',
    areaCode: '1397',
    square: '812-547',
    head4digits: '0139',
  },
  {
    codeMain: '31',
    codeSub: '',
    MAnum: '26',
    pref: '北海道',
    MAName: '熊石',
    areaCode: '1398',
    square: '810-566',
    head4digits: '0139',
  },
  {
    codeMain: '32',
    codeSub: '',
    MAnum: '27',
    pref: '北海道',
    MAName: '伊達',
    areaCode: '142',
    square: '829-602',
    head4digits: '0142',
  },
  {
    codeMain: '33',
    codeSub: '',
    MAnum: '28',
    pref: '北海道',
    MAName: '室蘭',
    areaCode: '143',
    square: '820-607',
    head4digits: '0143',
  },
  {
    codeMain: '34',
    codeSub: '',
    MAnum: '29',
    pref: '北海道',
    MAName: '苫小牧',
    areaCode: '144',
    square: '838-632',
    head4digits: '0144',
  },
  {
    codeMain: '35',
    codeSub: '',
    MAnum: '30',
    pref: '北海道',
    MAName: '早来',
    areaCode: '145',
    square: '845-641',
    head4digits: '0145',
  },
  {
    codeMain: '36',
    codeSub: '',
    MAnum: '31',
    pref: '北海道',
    MAName: '鵡川',
    areaCode: '145',
    square: '834-646',
    head4digits: '0145',
  },
  {
    codeMain: '37',
    codeSub: '',
    MAnum: '32',
    pref: '北海道',
    MAName: '門別富川',
    areaCode: '1456',
    square: '831-650',
    head4digits: '0145',
  },
  {
    codeMain: '38',
    codeSub: '',
    MAnum: '33',
    pref: '北海道',
    MAName: '門別富川',
    areaCode: '1457',
    square: '831-650',
    head4digits: '0145',
  },
  {
    codeMain: '39',
    codeSub: '2',
    MAnum: '34',
    pref: '北海道',
    MAName: '浦河',
    areaCode: '146',
    square: '811-681',
    head4digits: '0146',
  },
  {
    codeMain: '41',
    codeSub: '',
    MAnum: '35',
    pref: '北海道',
    MAName: '静内',
    areaCode: '146',
    square: '821-664',
    head4digits: '0146',
  },
  {
    codeMain: '42',
    codeSub: '',
    MAnum: '36',
    pref: '北海道',
    MAName: 'えりも',
    areaCode: '1466',
    square: '803-697',
    head4digits: '0146',
  },
  {
    codeMain: '43',
    codeSub: '',
    MAnum: '39',
    pref: '北海道',
    MAName: '網走',
    areaCode: '152',
    square: '915-738',
    head4digits: '0152',
  },
  {
    codeMain: '44',
    codeSub: '',
    MAnum: '40',
    pref: '北海道',
    MAName: '斜里',
    areaCode: '152',
    square: '909-754',
    head4digits: '0152',
  },
  {
    codeMain: '45',
    codeSub: '',
    MAnum: '41',
    pref: '北海道',
    MAName: '美幌',
    areaCode: '152',
    square: '904-732',
    head4digits: '0152',
  },
  {
    codeMain: '46',
    codeSub: '',
    MAnum: '42',
    pref: '北海道',
    MAName: '厚岸',
    areaCode: '153',
    square: '861-764',
    head4digits: '0153',
  },
  {
    codeMain: '47',
    codeSub: '',
    MAnum: '43',
    pref: '北海道',
    MAName: '根室',
    areaCode: '153',
    square: '877-793',
    head4digits: '0153',
  },
  {
    codeMain: '48',
    codeSub: '',
    MAnum: '44',
    pref: '北海道',
    MAName: '中標津',
    areaCode: '153',
    square: '889-767',
    head4digits: '0153',
  },
  {
    codeMain: '49',
    codeSub: '',
    MAnum: '45',
    pref: '北海道',
    MAName: '根室標津',
    areaCode: '153',
    square: '894-774',
    head4digits: '0153',
  },
  {
    codeMain: '50',
    codeSub: '',
    MAnum: '46',
    pref: '北海道',
    MAName: '釧路',
    areaCode: '154',
    square: '857-745',
    head4digits: '0154',
  },
  {
    codeMain: '51',
    codeSub: '',
    MAnum: '47',
    pref: '北海道',
    MAName: '白糠',
    areaCode: '1547',
    square: '855-733',
    head4digits: '0154',
  },
  {
    codeMain: '52',
    codeSub: '',
    MAnum: '37',
    pref: '北海道',
    MAName: '弟子屈',
    areaCode: '15',
    square: '885-747',
    head4digits: '0154',
  },
  {
    codeMain: '53',
    codeSub: '',
    MAnum: '48',
    pref: '北海道',
    MAName: '帯広',
    areaCode: '155',
    square: '854-698',
    head4digits: '0155',
  },
  {
    codeMain: '54',
    codeSub: '',
    MAnum: '38',
    pref: '北海道',
    MAName: '十勝池田',
    areaCode: '15',
    square: '854-707',
    head4digits: '0155',
  },
  {
    codeMain: '55',
    codeSub: '',
    MAnum: '49',
    pref: '北海道',
    MAName: '広尾',
    areaCode: '1558',
    square: '819-703',
    head4digits: '0155',
  },
  {
    codeMain: '56',
    codeSub: '',
    MAnum: '50',
    pref: '北海道',
    MAName: '本別',
    areaCode: '156',
    square: '865-714',
    head4digits: '0156',
  },
  {
    codeMain: '57',
    codeSub: '',
    MAnum: '52',
    pref: '北海道',
    MAName: '上士幌',
    areaCode: '1564',
    square: '871-700',
    head4digits: '0156',
  },
  {
    codeMain: '58',
    codeSub: '',
    MAnum: '51',
    pref: '北海道',
    MAName: '十勝清水',
    areaCode: '156',
    square: '859-684',
    head4digits: '0156',
  },
  {
    codeMain: '59',
    codeSub: '',
    MAnum: '53',
    pref: '北海道',
    MAName: '北見',
    areaCode: '157',
    square: '903-723',
    head4digits: '0157',
  },
  {
    codeMain: '60',
    codeSub: '2',
    MAnum: '54',
    pref: '北海道',
    MAName: '紋別',
    areaCode: '158',
    square: '933-700',
    head4digits: '0158',
  },
  {
    codeMain: '62',
    codeSub: '',
    MAnum: '55',
    pref: '北海道',
    MAName: '遠軽',
    areaCode: '158',
    square: '917-708',
    head4digits: '0158',
  },
  {
    codeMain: '63',
    codeSub: '',
    MAnum: '57',
    pref: '北海道',
    MAName: '中湧別',
    areaCode: '1586',
    square: '924-710',
    head4digits: '0158',
  },
  {
    codeMain: '64',
    codeSub: '',
    MAnum: '58',
    pref: '北海道',
    MAName: '中湧別',
    areaCode: '1587',
    square: '924-710',
    head4digits: '0158',
  },
  {
    codeMain: '65',
    codeSub: '',
    MAnum: '56',
    pref: '北海道',
    MAName: '興部',
    areaCode: '158',
    square: '940-691',
    head4digits: '0158',
  },
  {
    codeMain: '66',
    codeSub: '',
    MAnum: '59',
    pref: '北海道',
    MAName: '稚内',
    areaCode: '162',
    square: '992-632',
    head4digits: '0162',
  },
  {
    codeMain: '67',
    codeSub: '',
    MAnum: '62',
    pref: '北海道',
    MAName: '天塩',
    areaCode: '1632',
    square: '963-635',
    head4digits: '0163',
  },
  {
    codeMain: '68',
    codeSub: '',
    MAnum: '63',
    pref: '北海道',
    MAName: '浜頓別',
    areaCode: '1634',
    square: '976-659',
    head4digits: '0163',
  },
  {
    codeMain: '69',
    codeSub: '',
    MAnum: '64',
    pref: '北海道',
    MAName: '浜頓別',
    areaCode: '1635',
    square: '976-659',
    head4digits: '0163',
  },
  {
    codeMain: '70',
    codeSub: '',
    MAnum: '60',
    pref: '北海道',
    MAName: '北見枝幸',
    areaCode: '163',
    square: '966-668',
    head4digits: '0163',
  },
  {
    codeMain: '71',
    codeSub: '',
    MAnum: '61',
    pref: '北海道',
    MAName: '利尻礼文',
    areaCode: '163',
    square: '983-614',
    head4digits: '0163',
  },
  {
    codeMain: '72',
    codeSub: '',
    MAnum: '66',
    pref: '北海道',
    MAName: '留萌',
    areaCode: '164',
    square: '910-632',
    head4digits: '0164',
  },
  {
    codeMain: '73',
    codeSub: '',
    MAnum: '65',
    pref: '北海道',
    MAName: '石狩深川',
    areaCode: '164',
    square: '898-649',
    head4digits: '0164',
  },
  {
    codeMain: '74',
    codeSub: '',
    MAnum: '67',
    pref: '北海道',
    MAName: '羽幌',
    areaCode: '164',
    square: '934-634',
    head4digits: '0164',
  },
  {
    codeMain: '75',
    codeSub: '',
    MAnum: '68',
    pref: '北海道',
    MAName: '焼尻',
    areaCode: '1648',
    square: '938-623',
    head4digits: '0164',
  },
  {
    codeMain: '76',
    codeSub: '2',
    MAnum: '69',
    pref: '北海道',
    MAName: '士別',
    areaCode: '165',
    square: '923-662',
    head4digits: '0165',
  },
  {
    codeMain: '81',
    codeSub: '',
    MAnum: '70',
    pref: '北海道',
    MAName: '名寄',
    areaCode: '1654',
    square: '933-664',
    head4digits: '0165',
  },
  {
    codeMain: '82',
    codeSub: '',
    MAnum: '71',
    pref: '北海道',
    MAName: '名寄',
    areaCode: '1655',
    square: '933-664',
    head4digits: '0165',
  },
  {
    codeMain: '83',
    codeSub: '',
    MAnum: '72',
    pref: '北海道',
    MAName: '美深',
    areaCode: '1656',
    square: '940-660',
    head4digits: '0165',
  },
  {
    codeMain: '84',
    codeSub: '',
    MAnum: '73',
    pref: '北海道',
    MAName: '上川',
    areaCode: '1658',
    square: '905-678',
    head4digits: '0165',
  },
  {
    codeMain: '85',
    codeSub: '',
    MAnum: '74',
    pref: '北海道',
    MAName: '旭川',
    areaCode: '166',
    square: '901-662',
    head4digits: '0166',
  },
  {
    codeMain: '86',
    codeSub: '',
    MAnum: '75',
    pref: '北海道',
    MAName: '富良野',
    areaCode: '167',
    square: '877-663',
    head4digits: '0167',
  },
  {
    codeMain: '87',
    codeSub: '',
    MAnum: '77',
    pref: '青森県',
    MAName: '弘前',
    areaCode: '172',
    square: '725-587',
    head4digits: '0172',
  },
  {
    codeMain: '88',
    codeSub: '',
    MAnum: '79',
    pref: '青森県',
    MAName: '五所川原',
    areaCode: '173',
    square: '736-586',
    head4digits: '0173',
  },
  {
    codeMain: '89',
    codeSub: '',
    MAnum: '78',
    pref: '青森県',
    MAName: '鰺ケ沢',
    areaCode: '173',
    square: '735-576',
    head4digits: '0173',
  },
  {
    codeMain: '90',
    codeSub: '',
    MAnum: '80',
    pref: '青森県',
    MAName: '蟹田',
    areaCode: '174',
    square: '749-594',
    head4digits: '0174',
  },
  {
    codeMain: '91',
    codeSub: '',
    MAnum: '82',
    pref: '青森県',
    MAName: 'むつ',
    areaCode: '175',
    square: '763-618',
    head4digits: '0175',
  },
  {
    codeMain: '92',
    codeSub: '',
    MAnum: '81',
    pref: '青森県',
    MAName: '野辺地',
    areaCode: '175',
    square: '740-614',
    head4digits: '0175',
  },
  {
    codeMain: '93',
    codeSub: '',
    MAnum: '83',
    pref: '青森県',
    MAName: '十和田',
    areaCode: '176',
    square: '725-618',
    head4digits: '0176',
  },
  {
    codeMain: '94',
    codeSub: '2',
    MAnum: '76',
    pref: '青森県',
    MAName: '青森',
    areaCode: '17',
    square: '737-598',
    head4digits: '0177',
  },
  {
    codeMain: '95',
    codeSub: '',
    MAnum: '84',
    pref: '青森県',
    MAName: '八戸',
    areaCode: '178',
    square: '720-630',
    head4digits: '0178',
  },
  {
    codeMain: '96',
    codeSub: '',
    MAnum: '85',
    pref: '青森県',
    MAName: '三戸',
    areaCode: '179',
    square: '712-621',
    head4digits: '0179',
  },
  {
    codeMain: '97',
    codeSub: '',
    MAnum: '87',
    pref: '秋田県',
    MAName: '横手',
    areaCode: '182',
    square: '654-592',
    head4digits: '0182',
  },
  {
    codeMain: '98',
    codeSub: '',
    MAnum: '88',
    pref: '秋田県',
    MAName: '湯沢',
    areaCode: '183',
    square: '645-588',
    head4digits: '0183',
  },
  {
    codeMain: '99',
    codeSub: '',
    MAnum: '89',
    pref: '秋田県',
    MAName: '本荘',
    areaCode: '184',
    square: '658-569',
    head4digits: '0184',
  },
  {
    codeMain: '100',
    codeSub: '',
    MAnum: '91',
    pref: '秋田県',
    MAName: '男鹿',
    areaCode: '185',
    square: '685-561',
    head4digits: '0185',
  },
  {
    codeMain: '101',
    codeSub: '',
    MAnum: '90',
    pref: '秋田県',
    MAName: '能代',
    areaCode: '185',
    square: '703-568',
    head4digits: '0185',
  },
  {
    codeMain: '102',
    codeSub: '',
    MAnum: '92',
    pref: '秋田県',
    MAName: '鹿角',
    areaCode: '186',
    square: '702-601',
    head4digits: '0186',
  },
  {
    codeMain: '103',
    codeSub: '',
    MAnum: '93',
    pref: '秋田県',
    MAName: '大館',
    areaCode: '186',
    square: '707-591',
    head4digits: '0186',
  },
  {
    codeMain: '104',
    codeSub: '',
    MAnum: '94',
    pref: '秋田県',
    MAName: '鷹巣',
    areaCode: '186',
    square: '704-583',
    head4digits: '0186',
  },
  {
    codeMain: '105',
    codeSub: '',
    MAnum: '96',
    pref: '秋田県',
    MAName: '大曲',
    areaCode: '187',
    square: '661-588',
    head4digits: '0187',
  },
  {
    codeMain: '106',
    codeSub: '',
    MAnum: '95',
    pref: '秋田県',
    MAName: '角館',
    areaCode: '187',
    square: '669-591',
    head4digits: '0187',
  },
  {
    codeMain: '107',
    codeSub: '',
    MAnum: '86',
    pref: '秋田県',
    MAName: '秋田',
    areaCode: '18',
    square: '676-572',
    head4digits: '0188',
  },
  {
    codeMain: '108',
    codeSub: '',
    MAnum: '98',
    pref: '岩手県',
    MAName: '一関',
    areaCode: '191',
    square: '632-616',
    head4digits: '0191',
  },
  {
    codeMain: '109',
    codeSub: '',
    MAnum: '99',
    pref: '岩手県',
    MAName: '大船渡',
    areaCode: '192',
    square: '640-641',
    head4digits: '0192',
  },
  {
    codeMain: '110',
    codeSub: '',
    MAnum: '101',
    pref: '岩手県',
    MAName: '宮古',
    areaCode: '193',
    square: '672-651',
    head4digits: '0193',
  },
  {
    codeMain: '111',
    codeSub: '',
    MAnum: '100',
    pref: '岩手県',
    MAName: '釜石',
    areaCode: '193',
    square: '651-648',
    head4digits: '0193',
  },
  {
    codeMain: '112',
    codeSub: '',
    MAnum: '102',
    pref: '岩手県',
    MAName: '久慈',
    areaCode: '194',
    square: '702-642',
    head4digits: '0194',
  },
  {
    codeMain: '113',
    codeSub: '',
    MAnum: '103',
    pref: '岩手県',
    MAName: '岩泉',
    areaCode: '194',
    square: '683-644',
    head4digits: '0194',
  },
  {
    codeMain: '114',
    codeSub: '',
    MAnum: '105',
    pref: '岩手県',
    MAName: '岩手',
    areaCode: '195',
    square: '690-619',
    head4digits: '0195',
  },
  {
    codeMain: '115',
    codeSub: '',
    MAnum: '104',
    pref: '岩手県',
    MAName: '二戸',
    areaCode: '195',
    square: '706-622',
    head4digits: '0195',
  },
  {
    codeMain: '116',
    codeSub: '',
    MAnum: '97',
    pref: '岩手県',
    MAName: '盛岡',
    areaCode: '19',
    square: '675-617',
    head4digits: '0196',
  },
  {
    codeMain: '117',
    codeSub: '',
    MAnum: '106',
    pref: '岩手県',
    MAName: '水沢',
    areaCode: '197',
    square: '644-617',
    head4digits: '0197',
  },
  {
    codeMain: '118',
    codeSub: '',
    MAnum: '107',
    pref: '岩手県',
    MAName: '北上',
    areaCode: '197',
    square: '652-615',
    head4digits: '0197',
  },
  {
    codeMain: '119',
    codeSub: '',
    MAnum: '108',
    pref: '岩手県',
    MAName: '花巻',
    areaCode: '198',
    square: '657-615',
    head4digits: '0198',
  },
  {
    codeMain: '120',
    codeSub: '',
    MAnum: '109',
    pref: '岩手県',
    MAName: '遠野',
    areaCode: '198',
    square: '654-633',
    head4digits: '0198',
  },
  {
    codeMain: '121',
    codeSub: '',
    MAnum: '110',
    pref: '宮城県',
    MAName: '仙台',
    areaCode: '22',
    square: '595-605',
    head4digits: '0222',
  },
  {
    codeMain: '122',
    codeSub: '',
    MAnum: '111',
    pref: '宮城県',
    MAName: '迫',
    areaCode: '220',
    square: '619-619',
    head4digits: '0220',
  },
  {
    codeMain: '123',
    codeSub: '',
    MAnum: '112',
    pref: '宮城県',
    MAName: '岩沼',
    areaCode: '223',
    square: '586-605',
    head4digits: '0223',
  },
  {
    codeMain: '124',
    codeSub: '',
    MAnum: '113',
    pref: '宮城県',
    MAName: '大河原',
    areaCode: '224',
    square: '583-600',
    head4digits: '0224',
  },
  {
    codeMain: '125',
    codeSub: '',
    MAnum: '114',
    pref: '宮城県',
    MAName: '白石',
    areaCode: '224',
    square: '581-595',
    head4digits: '0224',
  },
  {
    codeMain: '126',
    codeSub: '',
    MAnum: '115',
    pref: '宮城県',
    MAName: '石巻',
    areaCode: '225',
    square: '604-624',
    head4digits: '0225',
  },
  {
    codeMain: '127',
    codeSub: '',
    MAnum: '116',
    pref: '宮城県',
    MAName: '気仙沼',
    areaCode: '226',
    square: '631-635',
    head4digits: '0226',
  },
  {
    codeMain: '128',
    codeSub: '',
    MAnum: '117',
    pref: '宮城県',
    MAName: '築館',
    areaCode: '228',
    square: '621-611',
    head4digits: '0228',
  },
  {
    codeMain: '129',
    codeSub: '',
    MAnum: '118',
    pref: '宮城県',
    MAName: '古川',
    areaCode: '229',
    square: '612-609',
    head4digits: '0229',
  },
  {
    codeMain: '130',
    codeSub: '',
    MAnum: '120',
    pref: '山形県',
    MAName: '新庄',
    areaCode: '233',
    square: '623-580',
    head4digits: '0233',
  },
  {
    codeMain: '131',
    codeSub: '',
    MAnum: '121',
    pref: '山形県',
    MAName: '酒田',
    areaCode: '234',
    square: '631-560',
    head4digits: '0234',
  },
  {
    codeMain: '132',
    codeSub: '',
    MAnum: '122',
    pref: '山形県',
    MAName: '鶴岡',
    areaCode: '235',
    square: '621-560',
    head4digits: '0235',
  },
  {
    codeMain: '133',
    codeSub: '',
    MAnum: '119',
    pref: '山形県',
    MAName: '山形',
    areaCode: '23',
    square: '595-582',
    head4digits: '0236',
  },
  {
    codeMain: '134',
    codeSub: '',
    MAnum: '124',
    pref: '山形県',
    MAName: '寒河江',
    areaCode: '237',
    square: '601-579',
    head4digits: '0237',
  },
  {
    codeMain: '135',
    codeSub: '',
    MAnum: '123',
    pref: '山形県',
    MAName: '村山',
    areaCode: '237',
    square: '607-584',
    head4digits: '0237',
  },
  {
    codeMain: '136',
    codeSub: '',
    MAnum: '126',
    pref: '山形県',
    MAName: '米沢',
    areaCode: '238',
    square: '576-572',
    head4digits: '0238',
  },
  {
    codeMain: '137',
    codeSub: '',
    MAnum: '125',
    pref: '山形県',
    MAName: '長井',
    areaCode: '238',
    square: '586-569',
    head4digits: '0238',
  },
  {
    codeMain: '138',
    codeSub: '',
    MAnum: '129',
    pref: '福島県',
    MAName: '磐城富岡',
    areaCode: '240',
    square: '544-612',
    head4digits: '0240',
  },
  {
    codeMain: '139',
    codeSub: '',
    MAnum: '130',
    pref: '福島県',
    MAName: '喜多方',
    areaCode: '241',
    square: '561-562',
    head4digits: '0241',
  },
  {
    codeMain: '140',
    codeSub: '',
    MAnum: '131',
    pref: '福島県',
    MAName: '田島',
    areaCode: '241',
    square: '536-557',
    head4digits: '0241',
  },
  {
    codeMain: '141',
    codeSub: '',
    MAnum: '133',
    pref: '福島県',
    MAName: '会津山口',
    areaCode: '241',
    square: '538-547',
    head4digits: '0241',
  },
  {
    codeMain: '142',
    codeSub: '',
    MAnum: '132',
    pref: '福島県',
    MAName: '柳津',
    areaCode: '241',
    square: '554-555',
    head4digits: '0241',
  },
  {
    codeMain: '143',
    codeSub: '',
    MAnum: '134',
    pref: '福島県',
    MAName: '会津若松',
    areaCode: '242',
    square: '552-564',
    head4digits: '0242',
  },
  {
    codeMain: '144',
    codeSub: '',
    MAnum: '135',
    pref: '福島県',
    MAName: '二本松',
    areaCode: '243',
    square: '558-587',
    head4digits: '0243',
  },
  {
    codeMain: '145',
    codeSub: '',
    MAnum: '136',
    pref: '福島県',
    MAName: '原町',
    areaCode: '244',
    square: '560-610',
    head4digits: '0244',
  },
  {
    codeMain: '146',
    codeSub: '',
    MAnum: '128',
    pref: '福島県',
    MAName: '福島',
    areaCode: '24',
    square: '567-588',
    head4digits: '0245',
  },
  {
    codeMain: '147',
    codeSub: '',
    MAnum: '137',
    pref: '福島県',
    MAName: 'いわき',
    areaCode: '246',
    square: '528-607',
    head4digits: '0246',
  },
  {
    codeMain: '148',
    codeSub: '',
    MAnum: '139',
    pref: '福島県',
    MAName: '石川',
    areaCode: '247',
    square: '533-588',
    head4digits: '0247',
  },
  {
    codeMain: '149',
    codeSub: '',
    MAnum: '138',
    pref: '福島県',
    MAName: '三春',
    areaCode: '247',
    square: '549-589',
    head4digits: '0247',
  },
  {
    codeMain: '150',
    codeSub: '',
    MAnum: '141',
    pref: '福島県',
    MAName: '須賀川',
    areaCode: '248',
    square: '541-584',
    head4digits: '0248',
  },
  {
    codeMain: '151',
    codeSub: '',
    MAnum: '140',
    pref: '福島県',
    MAName: '白河',
    areaCode: '248',
    square: '532-577',
    head4digits: '0248',
  },
  {
    codeMain: '152',
    codeSub: '',
    MAnum: '127',
    pref: '福島県',
    MAName: '郡山',
    areaCode: '24',
    square: '547-584',
    head4digits: '0249',
  },
  {
    codeMain: '153',
    codeSub: '',
    MAnum: '142',
    pref: '新潟県',
    MAName: '新潟',
    areaCode: '25',
    square: '576-526',
    head4digits: '0252',
  },
  {
    codeMain: '154',
    codeSub: '',
    MAnum: '149',
    pref: '新潟県',
    MAName: '新津',
    areaCode: '250',
    square: '569-529',
    head4digits: '0250',
  },
  {
    codeMain: '155',
    codeSub: '',
    MAnum: '150',
    pref: '新潟県',
    MAName: '新発田',
    areaCode: '254',
    square: '578-538',
    head4digits: '0254',
  },
  {
    codeMain: '156',
    codeSub: '',
    MAnum: '151',
    pref: '新潟県',
    MAName: '村上',
    areaCode: '254',
    square: '593-545',
    head4digits: '0254',
  },
  {
    codeMain: '157',
    codeSub: '',
    MAnum: '152',
    pref: '新潟県',
    MAName: '津川',
    areaCode: '254',
    square: '563-544',
    head4digits: '0254',
  },
  {
    codeMain: '158',
    codeSub: '',
    MAnum: '144',
    pref: '新潟県',
    MAName: '上越',
    areaCode: '25',
    square: '535-489',
    head4digits: '0255',
  },
  {
    codeMain: '159',
    codeSub: '',
    MAnum: '153',
    pref: '新潟県',
    MAName: '新井',
    areaCode: '255',
    square: '526-490',
    head4digits: '0255',
  },
  {
    codeMain: '160',
    codeSub: '',
    MAnum: '143',
    pref: '新潟県',
    MAName: '糸魚川',
    areaCode: '25',
    square: '527-473',
    head4digits: '0255',
  },
  {
    codeMain: '161',
    codeSub: '',
    MAnum: '145',
    pref: '新潟県',
    MAName: '安塚',
    areaCode: '25',
    square: '532-498',
    head4digits: '0255',
  },
  {
    codeMain: '162',
    codeSub: '',
    MAnum: '155',
    pref: '新潟県',
    MAName: '巻',
    areaCode: '256',
    square: '567-518',
    head4digits: '0256',
  },
  {
    codeMain: '163',
    codeSub: '',
    MAnum: '154',
    pref: '新潟県',
    MAName: '三条',
    areaCode: '256',
    square: '560-521',
    head4digits: '0256',
  },
  {
    codeMain: '164',
    codeSub: '',
    MAnum: '146',
    pref: '新潟県',
    MAName: '十日町',
    areaCode: '25',
    square: '532-512',
    head4digits: '0257',
  },
  {
    codeMain: '165',
    codeSub: '',
    MAnum: '156',
    pref: '新潟県',
    MAName: '柏崎',
    areaCode: '257',
    square: '545-503',
    head4digits: '0257',
  },
  {
    codeMain: '166',
    codeSub: '',
    MAnum: '147',
    pref: '新潟県',
    MAName: '六日町',
    areaCode: '25',
    square: '528-518',
    head4digits: '0257',
  },
  {
    codeMain: '167',
    codeSub: '',
    MAnum: '148',
    pref: '新潟県',
    MAName: '小出',
    areaCode: '25',
    square: '538-521',
    head4digits: '0257',
  },
  {
    codeMain: '168',
    codeSub: '',
    MAnum: '157',
    pref: '新潟県',
    MAName: '長岡',
    areaCode: '258',
    square: '550-517',
    head4digits: '0258',
  },
  {
    codeMain: '169',
    codeSub: '2',
    MAnum: '158',
    pref: '新潟県',
    MAName: '佐渡',
    areaCode: '259',
    square: '585-498',
    head4digits: '0259',
  },
  {
    codeMain: '171',
    codeSub: '',
    MAnum: '160',
    pref: '長野県',
    MAName: '阿南町',
    areaCode: '260',
    square: '432-469',
    head4digits: '0260',
  },
  {
    codeMain: '172',
    codeSub: '',
    MAnum: '161',
    pref: '長野県',
    MAName: '大町',
    areaCode: '261',
    square: '498-472',
    head4digits: '0261',
  },
  {
    codeMain: '173',
    codeSub: '',
    MAnum: '159',
    pref: '長野県',
    MAName: '長野',
    areaCode: '26',
    square: '506-486',
    head4digits: '0262',
  },
  {
    codeMain: '174',
    codeSub: '',
    MAnum: '162',
    pref: '長野県',
    MAName: '松本',
    areaCode: '263',
    square: '482-477',
    head4digits: '0263',
  },
  {
    codeMain: '175',
    codeSub: '',
    MAnum: '163',
    pref: '長野県',
    MAName: '木曾福島',
    areaCode: '264',
    square: '461-464',
    head4digits: '0264',
  },
  {
    codeMain: '176',
    codeSub: '',
    MAnum: '164',
    pref: '長野県',
    MAName: '伊那',
    areaCode: '265',
    square: '460-476',
    head4digits: '0265',
  },
  {
    codeMain: '177',
    codeSub: '',
    MAnum: '165',
    pref: '長野県',
    MAName: '飯田',
    areaCode: '265',
    square: '443-469',
    head4digits: '0265',
  },
  {
    codeMain: '178',
    codeSub: '',
    MAnum: '166',
    pref: '長野県',
    MAName: '諏訪',
    areaCode: '266',
    square: '472-483',
    head4digits: '0266',
  },
  {
    codeMain: '179',
    codeSub: '',
    MAnum: '168',
    pref: '長野県',
    MAName: '小諸',
    areaCode: '267',
    square: '488-497',
    head4digits: '0267',
  },
  {
    codeMain: '180',
    codeSub: '',
    MAnum: '167',
    pref: '長野県',
    MAName: '佐久',
    areaCode: '267',
    square: '482-499',
    head4digits: '0267',
  },
  {
    codeMain: '181',
    codeSub: '',
    MAnum: '169',
    pref: '長野県',
    MAName: '上田',
    areaCode: '268',
    square: '492-489',
    head4digits: '0268',
  },
  {
    codeMain: '182',
    codeSub: '',
    MAnum: '170',
    pref: '長野県',
    MAName: '中野',
    areaCode: '269',
    square: '511-495',
    head4digits: '0269',
  },
  {
    codeMain: '183',
    codeSub: '',
    MAnum: '171',
    pref: '長野県',
    MAName: '飯山',
    areaCode: '269',
    square: '517-495',
    head4digits: '0269',
  },
  {
    codeMain: '184',
    codeSub: '',
    MAnum: '174',
    pref: '群馬県',
    MAName: '伊勢崎',
    areaCode: '270',
    square: '487-531',
    head4digits: '0270',
  },
  {
    codeMain: '185',
    codeSub: '',
    MAnum: '172',
    pref: '群馬県',
    MAName: '前橋',
    areaCode: '27',
    square: '491-526',
    head4digits: '0272',
  },
  {
    codeMain: '186',
    codeSub: '',
    MAnum: '173',
    pref: '群馬県',
    MAName: '高崎',
    areaCode: '27',
    square: '487-523',
    head4digits: '0273',
  },
  {
    codeMain: '187',
    codeSub: '',
    MAnum: '176',
    pref: '群馬県',
    MAName: '富岡',
    areaCode: '274',
    square: '484-518',
    head4digits: '0274',
  },
  {
    codeMain: '188',
    codeSub: '',
    MAnum: '175',
    pref: '群馬県',
    MAName: '藤岡',
    areaCode: '274',
    square: '483-526',
    head4digits: '0274',
  },
  {
    codeMain: '189',
    codeSub: '',
    MAnum: '177',
    pref: '群馬県',
    MAName: '太田',
    areaCode: '276',
    square: '486-540',
    head4digits: '0276',
  },
  {
    codeMain: '190',
    codeSub: '',
    MAnum: '178',
    pref: '群馬県',
    MAName: '桐生',
    areaCode: '277',
    square: '492-538',
    head4digits: '0277',
  },
  {
    codeMain: '191',
    codeSub: '',
    MAnum: '179',
    pref: '群馬県',
    MAName: '沼田',
    areaCode: '278',
    square: '505-525',
    head4digits: '0278',
  },
  {
    codeMain: '192',
    codeSub: '',
    MAnum: '181',
    pref: '群馬県',
    MAName: '渋川',
    areaCode: '279',
    square: '497-523',
    head4digits: '0279',
  },
  {
    codeMain: '193',
    codeSub: '',
    MAnum: '180',
    pref: '群馬県',
    MAName: '長野原',
    areaCode: '279',
    square: '500-507',
    head4digits: '0279',
  },
  {
    codeMain: '194',
    codeSub: '',
    MAnum: '183',
    pref: '茨城県',
    MAName: '古河',
    areaCode: '280',
    square: '480-554',
    head4digits: '0280',
  },
  {
    codeMain: '195',
    codeSub: '',
    MAnum: '184',
    pref: '栃木県',
    MAName: '栃木',
    areaCode: '282',
    square: '490-556',
    head4digits: '0282',
  },
  {
    codeMain: '196',
    codeSub: '',
    MAnum: '185',
    pref: '栃木県',
    MAName: '佐野',
    areaCode: '283',
    square: '487-549',
    head4digits: '0283',
  },
  {
    codeMain: '197',
    codeSub: '',
    MAnum: '186',
    pref: '栃木県',
    MAName: '足利',
    areaCode: '284',
    square: '488-543',
    head4digits: '0284',
  },
  {
    codeMain: '198',
    codeSub: '',
    MAnum: '187',
    pref: '栃木県',
    MAName: '真岡',
    areaCode: '285',
    square: '494-568',
    head4digits: '0285',
  },
  {
    codeMain: '199',
    codeSub: '',
    MAnum: '188',
    pref: '栃木県',
    MAName: '小山',
    areaCode: '285',
    square: '487-559',
    head4digits: '0285',
  },
  {
    codeMain: '200',
    codeSub: '',
    MAnum: '182',
    pref: '栃木県',
    MAName: '宇都宮',
    areaCode: '28',
    square: '501-562',
    head4digits: '0286',
  },
  {
    codeMain: '201',
    codeSub: '',
    MAnum: '189',
    pref: '栃木県',
    MAName: '黒磯',
    areaCode: '287',
    square: '523-570',
    head4digits: '0287',
  },
  {
    codeMain: '202',
    codeSub: '',
    MAnum: '190',
    pref: '栃木県',
    MAName: '大田原',
    areaCode: '287',
    square: '518-569',
    head4digits: '0287',
  },
  {
    codeMain: '203',
    codeSub: '',
    MAnum: '191',
    pref: '栃木県',
    MAName: '烏山',
    areaCode: '287',
    square: '506-574',
    head4digits: '0287',
  },
  {
    codeMain: '204',
    codeSub: '',
    MAnum: '192',
    pref: '栃木県',
    MAName: '今市',
    areaCode: '288',
    square: '510-554',
    head4digits: '0288',
  },
  {
    codeMain: '205',
    codeSub: '',
    MAnum: '193',
    pref: '栃木県',
    MAName: '鹿沼',
    areaCode: '289',
    square: '501-556',
    head4digits: '0289',
  },
  {
    codeMain: '206',
    codeSub: '',
    MAnum: '196',
    pref: '茨城県',
    MAName: '鉾田',
    areaCode: '291',
    square: '478-590',
    head4digits: '0291',
  },
  {
    codeMain: '207',
    codeSub: '',
    MAnum: '194',
    pref: '茨城県',
    MAName: '水戸',
    areaCode: '29',
    square: '490-589',
    head4digits: '0292',
  },
  {
    codeMain: '208',
    codeSub: '',
    MAnum: '197',
    pref: '茨城県',
    MAName: '高萩',
    areaCode: '293',
    square: '509-599',
    head4digits: '0293',
  },
  {
    codeMain: '209',
    codeSub: '',
    MAnum: '198',
    pref: '茨城県',
    MAName: '常陸太田',
    areaCode: '294',
    square: '500-591',
    head4digits: '0294',
  },
  {
    codeMain: '210',
    codeSub: '2',
    MAnum: '199',
    pref: '茨城県',
    MAName: '常陸大宮',
    areaCode: '295',
    square: '500-586',
    head4digits: '0295',
  },
  {
    codeMain: '211',
    codeSub: '',
    MAnum: '200',
    pref: '茨城県',
    MAName: '大子',
    areaCode: '295',
    square: '512-583',
    head4digits: '0295',
  },
  {
    codeMain: '212',
    codeSub: '',
    MAnum: '201',
    pref: '茨城県',
    MAName: '笠間',
    areaCode: '296',
    square: '491-579',
    head4digits: '0296',
  },
  {
    codeMain: '213',
    codeSub: '',
    MAnum: '202',
    pref: '茨城県',
    MAName: '下館',
    areaCode: '296',
    square: '487-567',
    head4digits: '0296',
  },
  {
    codeMain: '214',
    codeSub: '',
    MAnum: '204',
    pref: '茨城県',
    MAName: '竜ケ崎',
    areaCode: '297',
    square: '464-576',
    head4digits: '0297',
  },
  {
    codeMain: '215',
    codeSub: '',
    MAnum: '203',
    pref: '茨城県',
    MAName: '水海道',
    areaCode: '297',
    square: '471-567',
    head4digits: '0297',
  },
  {
    codeMain: '216',
    codeSub: '',
    MAnum: '195',
    pref: '茨城県',
    MAName: '土浦',
    areaCode: '29',
    square: '474-577',
    head4digits: '0298',
  },
  {
    codeMain: '217',
    codeSub: '',
    MAnum: '205',
    pref: '茨城県',
    MAName: '石岡',
    areaCode: '299',
    square: '480-580',
    head4digits: '0299',
  },
  {
    codeMain: '218',
    codeSub: '',
    MAnum: '206',
    pref: '茨城県',
    MAName: '潮来',
    areaCode: '299',
    square: '466-592',
    head4digits: '0299',
  },
  {
    codeMain: '219',
    codeSub: '',
    MAnum: '207',
    pref: '東京都',
    MAName: '東京',
    areaCode: '3',
    square: '452-557',
    head4digits: '0331',
  },
  {
    codeMain: '220',
    codeSub: '',
    MAnum: '217',
    pref: '東京都',
    MAName: '武蔵野三鷹',
    areaCode: '422',
    square: '453-548',
    head4digits: '0422',
  },
  {
    codeMain: '221',
    codeSub: '',
    MAnum: '211',
    pref: '東京都',
    MAName: '国分寺',
    areaCode: '42',
    square: '453-544',
    head4digits: '0423',
  },
  {
    codeMain: '222',
    codeSub: '',
    MAnum: '216',
    pref: '東京都',
    MAName: '武蔵野三鷹',
    areaCode: '42',
    square: '453-548',
    head4digits: '0424',
  },
  {
    codeMain: '223',
    codeSub: '',
    MAnum: '212',
    pref: '東京都',
    MAName: '立川',
    areaCode: '42',
    square: '453-541',
    head4digits: '0425',
  },
  {
    codeMain: '224',
    codeSub: '',
    MAnum: '213',
    pref: '東京都',
    MAName: '八王子',
    areaCode: '42',
    square: '451-538',
    head4digits: '0426',
  },
  {
    codeMain: '225',
    codeSub: '',
    MAnum: '214',
    pref: '神奈川県',
    MAName: '相模原',
    areaCode: '42',
    square: '446-539',
    head4digits: '0427',
  },
  {
    codeMain: '226',
    codeSub: '',
    MAnum: '218',
    pref: '東京都',
    MAName: '青梅',
    areaCode: '428',
    square: '458-535',
    head4digits: '0428',
  },
  {
    codeMain: '227',
    codeSub: '',
    MAnum: '208',
    pref: '埼玉県',
    MAName: '所沢',
    areaCode: '4',
    square: '458-543',
    head4digits: '0429',
  },
  {
    codeMain: '228',
    codeSub: '',
    MAnum: '215',
    pref: '埼玉県',
    MAName: '飯能',
    areaCode: '42',
    square: '461-537',
    head4digits: '0429',
  },
  {
    codeMain: '229',
    codeSub: '',
    MAnum: '219',
    pref: '千葉県',
    MAName: '千葉',
    areaCode: '43',
    square: '448-573',
    head4digits: '0432',
  },
  {
    codeMain: '230',
    codeSub: '',
    MAnum: '220',
    pref: '千葉県',
    MAName: '市原',
    areaCode: '436',
    square: '443-572',
    head4digits: '0436',
  },
  {
    codeMain: '231',
    codeSub: '',
    MAnum: '221',
    pref: '千葉県',
    MAName: '木更津',
    areaCode: '438',
    square: '435-564',
    head4digits: '0438',
  },
  {
    codeMain: '232',
    codeSub: '',
    MAnum: '222',
    pref: '千葉県',
    MAName: '木更津',
    areaCode: '439',
    square: '435-564',
    head4digits: '0439',
  },
  {
    codeMain: '233',
    codeSub: '',
    MAnum: '223',
    pref: '神奈川県',
    MAName: '川崎',
    areaCode: '44',
    square: '443-554',
    head4digits: '0442',
  },
  {
    codeMain: '234',
    codeSub: '',
    MAnum: '224',
    pref: '神奈川県',
    MAName: '横浜',
    areaCode: '45',
    square: '439-551',
    head4digits: '0452',
  },
  {
    codeMain: '235',
    codeSub: '',
    MAnum: '227',
    pref: '神奈川県',
    MAName: '小田原',
    areaCode: '460',
    square: '428-529',
    head4digits: '0460',
  },
  {
    codeMain: '236',
    codeSub: '2',
    MAnum: '225',
    pref: '神奈川県',
    MAName: '厚木',
    areaCode: '46',
    square: '439-539',
    head4digits: '0462',
  },
  {
    codeMain: '237',
    codeSub: '',
    MAnum: '229',
    pref: '神奈川県',
    MAName: '平塚',
    areaCode: '463',
    square: '432-538',
    head4digits: '0463',
  },
  {
    codeMain: '238',
    codeSub: '',
    MAnum: '228',
    pref: '神奈川県',
    MAName: '小田原',
    areaCode: '465',
    square: '428-529',
    head4digits: '0465',
  },
  {
    codeMain: '239',
    codeSub: '',
    MAnum: '230',
    pref: '神奈川県',
    MAName: '藤沢',
    areaCode: '466',
    square: '433-545',
    head4digits: '0466',
  },
  {
    codeMain: '240',
    codeSub: '',
    MAnum: '231',
    pref: '神奈川県',
    MAName: '藤沢',
    areaCode: '467',
    square: '433-545',
    head4digits: '0467',
  },
  {
    codeMain: '241',
    codeSub: '',
    MAnum: '226',
    pref: '神奈川県',
    MAName: '横須賀',
    areaCode: '46',
    square: '430-553',
    head4digits: '0468',
  },
  {
    codeMain: '242',
    codeSub: '',
    MAnum: '234',
    pref: '千葉県',
    MAName: '館山',
    areaCode: '470',
    square: '413-562',
    head4digits: '0470',
  },
  {
    codeMain: '243',
    codeSub: '',
    MAnum: '235',
    pref: '千葉県',
    MAName: '大原',
    areaCode: '470',
    square: '428-585',
    head4digits: '0470',
  },
  {
    codeMain: '244',
    codeSub: '',
    MAnum: '209',
    pref: '千葉県',
    MAName: '鴨川',
    areaCode: '4',
    square: '420-573',
    head4digits: '0470',
  },
  {
    codeMain: '245',
    codeSub: '',
    MAnum: '210',
    pref: '千葉県',
    MAName: '柏',
    areaCode: '4',
    square: '461-566',
    head4digits: '0471',
  },
  {
    codeMain: '246',
    codeSub: '',
    MAnum: '232',
    pref: '千葉県',
    MAName: '市川',
    areaCode: '47',
    square: '454-564',
    head4digits: '0473',
  },
  {
    codeMain: '247',
    codeSub: '',
    MAnum: '233',
    pref: '千葉県',
    MAName: '船橋',
    areaCode: '47',
    square: '453-567',
    head4digits: '0474',
  },
  {
    codeMain: '248',
    codeSub: '',
    MAnum: '237',
    pref: '千葉県',
    MAName: '東金',
    areaCode: '475',
    square: '445-584',
    head4digits: '0475',
  },
  {
    codeMain: '249',
    codeSub: '',
    MAnum: '236',
    pref: '千葉県',
    MAName: '茂原',
    areaCode: '475',
    square: '438-581',
    head4digits: '0475',
  },
  {
    codeMain: '250',
    codeSub: '',
    MAnum: '238',
    pref: '千葉県',
    MAName: '成田',
    areaCode: '476',
    square: '458-582',
    head4digits: '0476',
  },
  {
    codeMain: '251',
    codeSub: '',
    MAnum: '239',
    pref: '千葉県',
    MAName: '佐原',
    areaCode: '478',
    square: '463-590',
    head4digits: '0478',
  },
  {
    codeMain: '252',
    codeSub: '',
    MAnum: '240',
    pref: '千葉県',
    MAName: '銚子',
    areaCode: '479',
    square: '455-605',
    head4digits: '0479',
  },
  {
    codeMain: '253',
    codeSub: '',
    MAnum: '241',
    pref: '千葉県',
    MAName: '八日市場',
    areaCode: '479',
    square: '453-592',
    head4digits: '0479',
  },
  {
    codeMain: '254',
    codeSub: '',
    MAnum: '243',
    pref: '埼玉県',
    MAName: '浦和',
    areaCode: '48',
    square: '462-552',
    head4digits: '0486',
  },
  {
    codeMain: '255',
    codeSub: '',
    MAnum: '242',
    pref: '埼玉県',
    MAName: '川口',
    areaCode: '48',
    square: '458-555',
    head4digits: '0482',
  },
  {
    codeMain: '256',
    codeSub: '',
    MAnum: '246',
    pref: '埼玉県',
    MAName: '久喜',
    areaCode: '480',
    square: '473-553',
    head4digits: '0480',
  },
  {
    codeMain: '257',
    codeSub: '2',
    MAnum: '244',
    pref: '埼玉県',
    MAName: '熊谷',
    areaCode: '48',
    square: '477-540',
    head4digits: '0485',
  },
  {
    codeMain: '258',
    codeSub: '',
    MAnum: '245',
    pref: '埼玉県',
    MAName: '草加',
    areaCode: '48',
    square: '460-559',
    head4digits: '0489',
  },
  {
    codeMain: '259',
    codeSub: '',
    MAnum: '247',
    pref: '埼玉県',
    MAName: '川越',
    areaCode: '49',
    square: '465-544',
    head4digits: '0492',
  },
  {
    codeMain: '260',
    codeSub: '',
    MAnum: '248',
    pref: '埼玉県',
    MAName: '東松山',
    areaCode: '493',
    square: '472-541',
    head4digits: '0493',
  },
  {
    codeMain: '261',
    codeSub: '',
    MAnum: '249',
    pref: '埼玉県',
    MAName: '秩父',
    areaCode: '494',
    square: '469-526',
    head4digits: '0494',
  },
  {
    codeMain: '262',
    codeSub: '',
    MAnum: '250',
    pref: '埼玉県',
    MAName: '本庄',
    areaCode: '495',
    square: '483-531',
    head4digits: '0495',
  },
  {
    codeMain: '263',
    codeSub: '',
    MAnum: '251',
    pref: '東京都',
    MAName: '伊豆大島',
    areaCode: '4992',
    square: '400-538',
    head4digits: '0499',
  },
  {
    codeMain: '264',
    codeSub: '',
    MAnum: '252',
    pref: '東京都',
    MAName: '三宅',
    areaCode: '4994',
    square: '365-546',
    head4digits: '0499',
  },
  {
    codeMain: '265',
    codeSub: '',
    MAnum: '253',
    pref: '東京都',
    MAName: '八丈島',
    areaCode: '4996',
    square: '309-558',
    head4digits: '0499',
  },
  {
    codeMain: '266',
    codeSub: '',
    MAnum: '254',
    pref: '東京都',
    MAName: '小笠原',
    areaCode: '4998',
    square: '(-024)-677',
    head4digits: '0499',
  },
  {
    codeMain: '267',
    codeSub: '',
    MAnum: '262',
    pref: '愛知県',
    MAName: '名古屋',
    areaCode: '52',
    square: '423-426',
    head4digits: '0522',
  },
  {
    codeMain: '268',
    codeSub: '',
    MAnum: '263',
    pref: '静岡県',
    MAName: '浜松',
    areaCode: '53',
    square: '398-464',
    head4digits: '0534',
  },
  {
    codeMain: '269',
    codeSub: '2',
    MAnum: '264',
    pref: '愛知県',
    MAName: '田原',
    areaCode: '531',
    square: '396-443',
    head4digits: '0531',
  },
  {
    codeMain: '272',
    codeSub: '',
    MAnum: '265',
    pref: '愛知県',
    MAName: '豊橋',
    areaCode: '532',
    square: '401-448',
    head4digits: '0532',
  },
  {
    codeMain: '273',
    codeSub: '',
    MAnum: '266',
    pref: '愛知県',
    MAName: '豊橋',
    areaCode: '533',
    square: '401-448',
    head4digits: '0533',
  },
  {
    codeMain: '274',
    codeSub: '2',
    MAnum: '267',
    pref: '愛知県',
    MAName: '新城',
    areaCode: '536',
    square: '409-453',
    head4digits: '0536',
  },
  {
    codeMain: '276',
    codeSub: '2',
    MAnum: '268',
    pref: '愛知県',
    MAName: '設楽',
    areaCode: '536',
    square: '419-457',
    head4digits: '0536',
  },
  {
    codeMain: '280',
    codeSub: '',
    MAnum: '269',
    pref: '静岡県',
    MAName: '掛川',
    areaCode: '537',
    square: '401-477',
    head4digits: '0537',
  },
  {
    codeMain: '281',
    codeSub: '',
    MAnum: '270',
    pref: '静岡県',
    MAName: '磐田',
    areaCode: '538',
    square: '398-469',
    head4digits: '0538',
  },
  {
    codeMain: '282',
    codeSub: '',
    MAnum: '271',
    pref: '静岡県',
    MAName: '天竜',
    areaCode: '539',
    square: '404-469',
    head4digits: '0539',
  },
  {
    codeMain: '283',
    codeSub: '2',
    MAnum: '272',
    pref: '静岡県',
    MAName: '静岡',
    areaCode: '54',
    square: '412-494',
    head4digits: '0542',
  },
  {
    codeMain: '285',
    codeSub: '',
    MAnum: '273',
    pref: '静岡県',
    MAName: '富士宮',
    areaCode: '544',
    square: '426-505',
    head4digits: '0544',
  },
  {
    codeMain: '286',
    codeSub: '',
    MAnum: '274',
    pref: '静岡県',
    MAName: '富士',
    areaCode: '545',
    square: '423-508',
    head4digits: '0545',
  },
  {
    codeMain: '287',
    codeSub: '',
    MAnum: '275',
    pref: '静岡県',
    MAName: '島田',
    areaCode: '547',
    square: '405-484',
    head4digits: '0547',
  },
  {
    codeMain: '288',
    codeSub: '',
    MAnum: '276',
    pref: '静岡県',
    MAName: '榛原',
    areaCode: '548',
    square: '400-487',
    head4digits: '0548',
  },
  {
    codeMain: '289',
    codeSub: '',
    MAnum: '277',
    pref: '静岡県',
    MAName: '御殿場',
    areaCode: '550',
    square: '431-519',
    head4digits: '0550',
  },
  {
    codeMain: '290',
    codeSub: '',
    MAnum: '256',
    pref: '山梨県',
    MAName: '韮崎',
    areaCode: '551',
    square: '453-498',
    head4digits: '0551',
  },
  {
    codeMain: '291',
    codeSub: '',
    MAnum: '255',
    pref: '山梨県',
    MAName: '甲府',
    areaCode: '55',
    square: '451-503',
    head4digits: '0552',
  },
  {
    codeMain: '292',
    codeSub: '',
    MAnum: '257',
    pref: '山梨県',
    MAName: '山梨',
    areaCode: '553',
    square: '452-508',
    head4digits: '0553',
  },
  {
    codeMain: '293',
    codeSub: '',
    MAnum: '258',
    pref: '山梨県',
    MAName: '大月',
    areaCode: '554',
    square: '448-520',
    head4digits: '0554',
  },
  {
    codeMain: '294',
    codeSub: '',
    MAnum: '259',
    pref: '山梨県',
    MAName: '吉田',
    areaCode: '555',
    square: '441-514',
    head4digits: '0555',
  },
  {
    codeMain: '295',
    codeSub: '',
    MAnum: '260',
    pref: '山梨県',
    MAName: '鰍沢青柳',
    areaCode: '556',
    square: '444-498',
    head4digits: '0556',
  },
  {
    codeMain: '296',
    codeSub: '',
    MAnum: '261',
    pref: '山梨県',
    MAName: '身延',
    areaCode: '556',
    square: '435-496',
    head4digits: '0556',
  },
  {
    codeMain: '297',
    codeSub: '',
    MAnum: '278',
    pref: '静岡県',
    MAName: '伊東',
    areaCode: '557',
    square: '412-527',
    head4digits: '0557',
  },
  {
    codeMain: '298',
    codeSub: '',
    MAnum: '279',
    pref: '静岡県',
    MAName: '修善寺大仁',
    areaCode: '558',
    square: '413-520',
    head4digits: '0558',
  },
  {
    codeMain: '299',
    codeSub: '',
    MAnum: '280',
    pref: '静岡県',
    MAName: '下田',
    areaCode: '558',
    square: '396-519',
    head4digits: '0558',
  },
  {
    codeMain: '300',
    codeSub: '',
    MAnum: '281',
    pref: '静岡県',
    MAName: '沼津',
    areaCode: '55',
    square: '420-516',
    head4digits: '0559',
  },
  {
    codeMain: '301',
    codeSub: '3',
    MAnum: '282',
    pref: '愛知県',
    MAName: '瀬戸',
    areaCode: '561',
    square: '426-436',
    head4digits: '0561',
  },
  {
    codeMain: '304',
    codeSub: '',
    MAnum: '283',
    pref: '愛知県',
    MAName: '尾張横須賀',
    areaCode: '562',
    square: '415-425',
    head4digits: '0562',
  },
  {
    codeMain: '305',
    codeSub: '',
    MAnum: '284',
    pref: '愛知県',
    MAName: '西尾',
    areaCode: '563',
    square: '407-433',
    head4digits: '0563',
  },
  {
    codeMain: '306',
    codeSub: '',
    MAnum: '285',
    pref: '愛知県',
    MAName: '岡崎',
    areaCode: '564',
    square: '411-439',
    head4digits: '0564',
  },
  {
    codeMain: '307',
    codeSub: '',
    MAnum: '286',
    pref: '愛知県',
    MAName: '豊田',
    areaCode: '565',
    square: '419-438',
    head4digits: '0565',
  },
  {
    codeMain: '308',
    codeSub: '',
    MAnum: '287',
    pref: '愛知県',
    MAName: '刈谷',
    areaCode: '566',
    square: '413-431',
    head4digits: '0566',
  },
  {
    codeMain: '309',
    codeSub: '2',
    MAnum: '288',
    pref: '愛知県',
    MAName: '津島',
    areaCode: '567',
    square: '424-419',
    head4digits: '0567',
  },
  {
    codeMain: '312',
    codeSub: '',
    MAnum: '289',
    pref: '愛知県',
    MAName: '春日井',
    areaCode: '568',
    square: '428-430',
    head4digits: '0568',
  },
  {
    codeMain: '313',
    codeSub: '',
    MAnum: '290',
    pref: '愛知県',
    MAName: '半田',
    areaCode: '569',
    square: '408-428',
    head4digits: '0569',
  },
  {
    codeMain: '314',
    codeSub: '',
    MAnum: '291',
    pref: '岐阜県',
    MAName: '多治見',
    areaCode: '572',
    square: '432-437',
    head4digits: '0572',
  },
  {
    codeMain: '315',
    codeSub: '',
    MAnum: '292',
    pref: '岐阜県',
    MAName: '恵那',
    areaCode: '573',
    square: '439-450',
    head4digits: '0573',
  },
  {
    codeMain: '316',
    codeSub: '',
    MAnum: '293',
    pref: '岐阜県',
    MAName: '中津川',
    areaCode: '573',
    square: '441-454',
    head4digits: '0573',
  },
  {
    codeMain: '317',
    codeSub: '',
    MAnum: '294',
    pref: '岐阜県',
    MAName: '美濃加茂',
    areaCode: '574',
    square: '438-432',
    head4digits: '0574',
  },
  {
    codeMain: '318',
    codeSub: '',
    MAnum: '295',
    pref: '岐阜県',
    MAName: '美濃白川',
    areaCode: '574',
    square: '446-440',
    head4digits: '0574',
  },
  {
    codeMain: '319',
    codeSub: '',
    MAnum: '296',
    pref: '岐阜県',
    MAName: '関',
    areaCode: '575',
    square: '441-428',
    head4digits: '0575',
  },
  {
    codeMain: '320',
    codeSub: '',
    MAnum: '297',
    pref: '岐阜県',
    MAName: '郡上八幡',
    areaCode: '575',
    square: '456-430',
    head4digits: '0575',
  },
  {
    codeMain: '321',
    codeSub: '',
    MAnum: '298',
    pref: '岐阜県',
    MAName: '下呂',
    areaCode: '576',
    square: '459-443',
    head4digits: '0576',
  },
  {
    codeMain: '322',
    codeSub: '',
    MAnum: '299',
    pref: '岐阜県',
    MAName: '荘川',
    areaCode: '5769',
    square: '471-431',
    head4digits: '0576',
  },
  {
    codeMain: '323',
    codeSub: '',
    MAnum: '300',
    pref: '岐阜県',
    MAName: '高山',
    areaCode: '577',
    square: '477-444',
    head4digits: '0577',
  },
  {
    codeMain: '324',
    codeSub: '',
    MAnum: '301',
    pref: '岐阜県',
    MAName: '神岡',
    areaCode: '578',
    square: '488-446',
    head4digits: '0578',
  },
  {
    codeMain: '325',
    codeSub: '2',
    MAnum: '302',
    pref: '岐阜県',
    MAName: '岐阜',
    areaCode: '58',
    square: '437-421',
    head4digits: '0582',
  },
  {
    codeMain: '326',
    codeSub: '3',
    MAnum: '303',
    pref: '岐阜県',
    MAName: '高富',
    areaCode: '581',
    square: '442-422',
    head4digits: '0581',
  },
  {
    codeMain: '332',
    codeSub: '',
    MAnum: '304',
    pref: '岐阜県',
    MAName: '大垣',
    areaCode: '584',
    square: '434-414',
    head4digits: '0584',
  },
  {
    codeMain: '333',
    codeSub: '',
    MAnum: '305',
    pref: '岐阜県',
    MAName: '揖斐川',
    areaCode: '585',
    square: '441-412',
    head4digits: '0585',
  },
  {
    codeMain: '334',
    codeSub: '2',
    MAnum: '306',
    pref: '愛知県',
    MAName: '一宮',
    areaCode: '586',
    square: '431-422',
    head4digits: '0586',
  },
  {
    codeMain: '336',
    codeSub: '',
    MAnum: '307',
    pref: '愛知県',
    MAName: '一宮',
    areaCode: '587',
    square: '431-422',
    head4digits: '0587',
  },
  {
    codeMain: '337',
    codeSub: '',
    MAnum: '308',
    pref: '三重県',
    MAName: '津',
    areaCode: '59',
    square: '398-408',
    head4digits: '0592',
  },
  {
    codeMain: '338',
    codeSub: '',
    MAnum: '309',
    pref: '三重県',
    MAName: '四日市',
    areaCode: '59',
    square: '412-414',
    head4digits: '0593',
  },
  {
    codeMain: '339',
    codeSub: '',
    MAnum: '310',
    pref: '三重県',
    MAName: '桑名',
    areaCode: '594',
    square: '418-417',
    head4digits: '0594',
  },
  {
    codeMain: '340',
    codeSub: '',
    MAnum: '311',
    pref: '三重県',
    MAName: '上野',
    areaCode: '595',
    square: '401-391',
    head4digits: '0595',
  },
  {
    codeMain: '341',
    codeSub: '2',
    MAnum: '312',
    pref: '三重県',
    MAName: '亀山',
    areaCode: '595',
    square: '406-406',
    head4digits: '0595',
  },
  {
    codeMain: '343',
    codeSub: '',
    MAnum: '313',
    pref: '三重県',
    MAName: '伊勢',
    areaCode: '596',
    square: '386-417',
    head4digits: '0596',
  },
  {
    codeMain: '344',
    codeSub: '3',
    MAnum: '314',
    pref: '三重県',
    MAName: '尾鷲',
    areaCode: '597',
    square: '362-392',
    head4digits: '0597',
  },
  {
    codeMain: '347',
    codeSub: '',
    MAnum: '315',
    pref: '三重県',
    MAName: '熊野',
    areaCode: '597',
    square: '352-388',
    head4digits: '0597',
  },
  {
    codeMain: '348',
    codeSub: '',
    MAnum: '316',
    pref: '三重県',
    MAName: '熊野',
    areaCode: '5979',
    square: '352-388',
    head4digits: '0597',
  },
  {
    codeMain: '349',
    codeSub: '2',
    MAnum: '317',
    pref: '三重県',
    MAName: '松阪',
    areaCode: '598',
    square: '390-409',
    head4digits: '0598',
  },
  {
    codeMain: '355',
    codeSub: '2',
    MAnum: '318',
    pref: '三重県',
    MAName: '三瀬谷',
    areaCode: '598',
    square: '380-403',
    head4digits: '0598',
  },
  {
    codeMain: '357',
    codeSub: '',
    MAnum: '319',
    pref: '三重県',
    MAName: '鳥羽',
    areaCode: '599',
    square: '385-423',
    head4digits: '0599',
  },
  {
    codeMain: '358',
    codeSub: '2',
    MAnum: '320',
    pref: '三重県',
    MAName: '阿児',
    areaCode: '599',
    square: '377-422',
    head4digits: '0599',
  },
  {
    codeMain: '363',
    codeSub: '',
    MAnum: '321',
    pref: '大阪府',
    MAName: '大阪',
    areaCode: '6',
    square: '397-361',
    head4digits: '0641',
  },
  {
    codeMain: '364',
    codeSub: '',
    MAnum: '322',
    pref: '大阪府',
    MAName: '寝屋川',
    areaCode: '72',
    square: '401-368',
    head4digits: '0728',
  },
  {
    codeMain: '365',
    codeSub: '',
    MAnum: '323',
    pref: '大阪府',
    MAName: '富田林',
    areaCode: '721',
    square: '386-366',
    head4digits: '0721',
  },
  {
    codeMain: '366',
    codeSub: '2',
    MAnum: '324',
    pref: '大阪府',
    MAName: '堺',
    areaCode: '72',
    square: '391-360',
    head4digits: '0722',
  },
  {
    codeMain: '368',
    codeSub: '',
    MAnum: '325',
    pref: '大阪府',
    MAName: '岸和田貝塚',
    areaCode: '72',
    square: '384-355',
    head4digits: '0724',
  },
  {
    codeMain: '369',
    codeSub: '',
    MAnum: '326',
    pref: '大阪府',
    MAName: '和泉',
    areaCode: '725',
    square: '386-358',
    head4digits: '0725',
  },
  {
    codeMain: '370',
    codeSub: '',
    MAnum: '327',
    pref: '大阪府',
    MAName: '茨木',
    areaCode: '72',
    square: '404-365',
    head4digits: '0726',
  },
  {
    codeMain: '371',
    codeSub: '',
    MAnum: '328',
    pref: '大阪府',
    MAName: '池田',
    areaCode: '72',
    square: '404-359',
    head4digits: '0727',
  },
  {
    codeMain: '372',
    codeSub: '',
    MAnum: '329',
    pref: '大阪府',
    MAName: '八尾',
    areaCode: '72',
    square: '393-366',
    head4digits: '0729',
  },
  {
    codeMain: '373',
    codeSub: '2',
    MAnum: '330',
    pref: '和歌山県',
    MAName: '和歌山',
    areaCode: '73',
    square: '371-346',
    head4digits: '0734',
  },
  {
    codeMain: '374',
    codeSub: '',
    MAnum: '331',
    pref: '和歌山県',
    MAName: '新宮',
    areaCode: '735',
    square: '343-382',
    head4digits: '0735',
  },
  {
    codeMain: '375',
    codeSub: '',
    MAnum: '332',
    pref: '和歌山県',
    MAName: '串本',
    areaCode: '735',
    square: '329-372',
    head4digits: '0735',
  },
  {
    codeMain: '376',
    codeSub: '',
    MAnum: '333',
    pref: '和歌山県',
    MAName: '岩出',
    areaCode: '736',
    square: '373-352',
    head4digits: '0736',
  },
  {
    codeMain: '377',
    codeSub: '',
    MAnum: '334',
    pref: '和歌山県',
    MAName: '和歌山橋本',
    areaCode: '736',
    square: '376-366',
    head4digits: '0736',
  },
  {
    codeMain: '378',
    codeSub: '',
    MAnum: '335',
    pref: '和歌山県',
    MAName: '湯浅',
    areaCode: '737',
    square: '360-345',
    head4digits: '0737',
  },
  {
    codeMain: '379',
    codeSub: '',
    MAnum: '336',
    pref: '和歌山県',
    MAName: '御坊',
    areaCode: '738',
    square: '352-344',
    head4digits: '0738',
  },
  {
    codeMain: '380',
    codeSub: '',
    MAnum: '337',
    pref: '和歌山県',
    MAName: '田辺',
    areaCode: '739',
    square: '344-354',
    head4digits: '0739',
  },
  {
    codeMain: '381',
    codeSub: '',
    MAnum: '338',
    pref: '滋賀県',
    MAName: '今津',
    areaCode: '740',
    square: '436-388',
    head4digits: '0740',
  },
  {
    codeMain: '382',
    codeSub: '',
    MAnum: '339',
    pref: '奈良県',
    MAName: '奈良',
    areaCode: '742',
    square: '396-377',
    head4digits: '0742',
  },
  {
    codeMain: '383',
    codeSub: '2',
    MAnum: '340',
    pref: '奈良県',
    MAName: '奈良',
    areaCode: '743',
    square: '396-377',
    head4digits: '0743',
  },
  {
    codeMain: '385',
    codeSub: '2',
    MAnum: '341',
    pref: '奈良県',
    MAName: '大和高田',
    areaCode: '744',
    square: '387-372',
    head4digits: '0744',
  },
  {
    codeMain: '387',
    codeSub: '',
    MAnum: '342',
    pref: '奈良県',
    MAName: '大和高田',
    areaCode: '745',
    square: '387-372',
    head4digits: '0745',
  },
  {
    codeMain: '388',
    codeSub: '',
    MAnum: '343',
    pref: '奈良県',
    MAName: '大和榛原',
    areaCode: '745',
    square: '388-382',
    head4digits: '0745',
  },
  {
    codeMain: '389',
    codeSub: '2',
    MAnum: '344',
    pref: '奈良県',
    MAName: '吉野',
    areaCode: '746',
    square: '380-377',
    head4digits: '0746',
  },
  {
    codeMain: '392',
    codeSub: '',
    MAnum: '345',
    pref: '奈良県',
    MAName: '十津川',
    areaCode: '746',
    square: '358-374',
    head4digits: '0746',
  },
  {
    codeMain: '393',
    codeSub: '',
    MAnum: '346',
    pref: '奈良県',
    MAName: '上北山',
    areaCode: '7468',
    square: '366-384',
    head4digits: '0746',
  },
  {
    codeMain: '394',
    codeSub: '2',
    MAnum: '347',
    pref: '奈良県',
    MAName: '五条',
    areaCode: '747',
    square: '378-370',
    head4digits: '0747',
  },
  {
    codeMain: '396',
    codeSub: '',
    MAnum: '348',
    pref: '奈良県',
    MAName: '下市',
    areaCode: '747',
    square: '379-374',
    head4digits: '0747',
  },
  {
    codeMain: '397',
    codeSub: '',
    MAnum: '349',
    pref: '滋賀県',
    MAName: '八日市',
    areaCode: '748',
    square: '420-395',
    head4digits: '0748',
  },
  {
    codeMain: '398',
    codeSub: '',
    MAnum: '350',
    pref: '滋賀県',
    MAName: '水口',
    areaCode: '748',
    square: '412-393',
    head4digits: '0748',
  },
  {
    codeMain: '399',
    codeSub: '',
    MAnum: '351',
    pref: '滋賀県',
    MAName: '彦根',
    areaCode: '749',
    square: '429-397',
    head4digits: '0749',
  },
  {
    codeMain: '400',
    codeSub: '',
    MAnum: '352',
    pref: '滋賀県',
    MAName: '長浜',
    areaCode: '749',
    square: '435-398',
    head4digits: '0749',
  },
  {
    codeMain: '401',
    codeSub: '',
    MAnum: '353',
    pref: '京都府',
    MAName: '京都',
    areaCode: '75',
    square: '414-374',
    head4digits: '0752',
  },
  {
    codeMain: '402',
    codeSub: '',
    MAnum: '354',
    pref: '石川県',
    MAName: '小松',
    areaCode: '761',
    square: '492-408',
    head4digits: '0761',
  },
  {
    codeMain: '403',
    codeSub: '2',
    MAnum: '355',
    pref: '石川県',
    MAName: '加賀',
    areaCode: '761',
    square: '486-402',
    head4digits: '0761',
  },
  {
    codeMain: '405',
    codeSub: '2',
    MAnum: '356',
    pref: '石川県',
    MAName: '金沢',
    areaCode: '76',
    square: '501-418',
    head4digits: '0762',
  },
  {
    codeMain: '406',
    codeSub: '',
    MAnum: '357',
    pref: '富山県',
    MAName: '福野',
    areaCode: '763',
    square: '502-430',
    head4digits: '0763',
  },
  {
    codeMain: '407',
    codeSub: '2',
    MAnum: '358',
    pref: '富山県',
    MAName: '富山',
    areaCode: '76',
    square: '508-443',
    head4digits: '0764',
  },
  {
    codeMain: '408',
    codeSub: '',
    MAnum: '359',
    pref: '富山県',
    MAName: '魚津',
    areaCode: '765',
    square: '515-451',
    head4digits: '0765',
  },
  {
    codeMain: '409',
    codeSub: '',
    MAnum: '360',
    pref: '富山県',
    MAName: '高岡',
    areaCode: '766',
    square: '511-434',
    head4digits: '0766',
  },
  {
    codeMain: '410',
    codeSub: '',
    MAnum: '361',
    pref: '石川県',
    MAName: '七尾',
    areaCode: '767',
    square: '527-432',
    head4digits: '0767',
  },
  {
    codeMain: '411',
    codeSub: '',
    MAnum: '362',
    pref: '石川県',
    MAName: '羽咋',
    areaCode: '767',
    square: '519-424',
    head4digits: '0767',
  },
  {
    codeMain: '412',
    codeSub: '',
    MAnum: '363',
    pref: '石川県',
    MAName: '輪島',
    areaCode: '768',
    square: '547-431',
    head4digits: '0768',
  },
  {
    codeMain: '413',
    codeSub: '',
    MAnum: '364',
    pref: '石川県',
    MAName: '能都',
    areaCode: '768',
    square: '542-441',
    head4digits: '0768',
  },
  {
    codeMain: '414',
    codeSub: '',
    MAnum: '365',
    pref: '福井県',
    MAName: '敦賀',
    areaCode: '770',
    square: '450-390',
    head4digits: '0770',
  },
  {
    codeMain: '415',
    codeSub: '',
    MAnum: '366',
    pref: '福井県',
    MAName: '小浜',
    areaCode: '770',
    square: '442-375',
    head4digits: '0770',
  },
  {
    codeMain: '416',
    codeSub: '',
    MAnum: '367',
    pref: '京都府',
    MAName: '亀岡',
    areaCode: '771',
    square: '415-366',
    head4digits: '0771',
  },
  {
    codeMain: '417',
    codeSub: '',
    MAnum: '368',
    pref: '京都府',
    MAName: '園部',
    areaCode: '771',
    square: '420-361',
    head4digits: '0771',
  },
  {
    codeMain: '418',
    codeSub: '',
    MAnum: '369',
    pref: '京都府',
    MAName: '宮津',
    areaCode: '772',
    square: '444-350',
    head4digits: '0772',
  },
  {
    codeMain: '419',
    codeSub: '',
    MAnum: '370',
    pref: '京都府',
    MAName: '峰山',
    areaCode: '772',
    square: '448-344',
    head4digits: '0772',
  },
  {
    codeMain: '420',
    codeSub: '',
    MAnum: '371',
    pref: '京都府',
    MAName: '福知山',
    areaCode: '773',
    square: '431-346',
    head4digits: '0773',
  },
  {
    codeMain: '421',
    codeSub: '',
    MAnum: '372',
    pref: '京都府',
    MAName: '舞鶴',
    areaCode: '773',
    square: '440-358',
    head4digits: '0773',
  },
  {
    codeMain: '422',
    codeSub: '',
    MAnum: '373',
    pref: '京都府',
    MAName: '宇治',
    areaCode: '774',
    square: '408-376',
    head4digits: '0774',
  },
  {
    codeMain: '423',
    codeSub: '',
    MAnum: '374',
    pref: '滋賀県',
    MAName: '大津',
    areaCode: '77',
    square: '414-379',
    head4digits: '0775',
  },
  {
    codeMain: '424',
    codeSub: '2',
    MAnum: '375',
    pref: '福井県',
    MAName: '福井',
    areaCode: '776',
    square: '473-397',
    head4digits: '0776',
  },
  {
    codeMain: '425',
    codeSub: '',
    MAnum: '376',
    pref: '福井県',
    MAName: '武生',
    areaCode: '778',
    square: '464-395',
    head4digits: '0778',
  },
  {
    codeMain: '426',
    codeSub: '',
    MAnum: '377',
    pref: '福井県',
    MAName: '大野',
    areaCode: '779',
    square: '469-409',
    head4digits: '0779',
  },
  {
    codeMain: '428',
    codeSub: '',
    MAnum: '378',
    pref: '兵庫県',
    MAName: '神戸',
    areaCode: '78',
    square: '396-347',
    head4digits: '0782',
  },
  {
    codeMain: '429',
    codeSub: '',
    MAnum: '379',
    pref: '兵庫県',
    MAName: '播磨山崎',
    areaCode: '790',
    square: '414-318',
    head4digits: '0790',
  },
  {
    codeMain: '430',
    codeSub: '',
    MAnum: '380',
    pref: '兵庫県',
    MAName: '福崎',
    areaCode: '790',
    square: '412-329',
    head4digits: '0790',
  },
  {
    codeMain: '431',
    codeSub: '',
    MAnum: '381',
    pref: '兵庫県',
    MAName: '竜野',
    areaCode: '791',
    square: '406-318',
    head4digits: '0791',
  },
  {
    codeMain: '432',
    codeSub: '2',
    MAnum: '382',
    pref: '兵庫県',
    MAName: '相生',
    areaCode: '791',
    square: '403-315',
    head4digits: '0791',
  },
  {
    codeMain: '435',
    codeSub: '2',
    MAnum: '383',
    pref: '兵庫県',
    MAName: '姫路',
    areaCode: '79',
    square: '405-325',
    head4digits: '0792',
  },
  {
    codeMain: '438',
    codeSub: '',
    MAnum: '384',
    pref: '兵庫県',
    MAName: '加古川',
    areaCode: '79',
    square: '401-332',
    head4digits: '0794',
  },
  {
    codeMain: '439',
    codeSub: '',
    MAnum: '385',
    pref: '兵庫県',
    MAName: '三木',
    areaCode: '794',
    square: '403-338',
    head4digits: '0794',
  },
  {
    codeMain: '440',
    codeSub: '',
    MAnum: '386',
    pref: '兵庫県',
    MAName: '西脇',
    areaCode: '795',
    square: '413-338',
    head4digits: '0795',
  },
  {
    codeMain: '441',
    codeSub: '',
    MAnum: '387',
    pref: '兵庫県',
    MAName: '三田',
    areaCode: '79',
    square: '408-350',
    head4digits: '0795',
  },
  {
    codeMain: '442',
    codeSub: '',
    MAnum: '388',
    pref: '兵庫県',
    MAName: '丹波柏原',
    areaCode: '795',
    square: '421-343',
    head4digits: '0795',
  },
  {
    codeMain: '443',
    codeSub: '',
    MAnum: '389',
    pref: '兵庫県',
    MAName: '豊岡',
    areaCode: '796',
    square: '444-333',
    head4digits: '0796',
  },
  {
    codeMain: '444',
    codeSub: '',
    MAnum: '390',
    pref: '兵庫県',
    MAName: '浜坂',
    areaCode: '796',
    square: '449-316',
    head4digits: '0796',
  },
  {
    codeMain: '445',
    codeSub: '',
    MAnum: '391',
    pref: '兵庫県',
    MAName: '八鹿',
    areaCode: '79',
    square: '437-330',
    head4digits: '0796',
  },
  {
    codeMain: '446',
    codeSub: '',
    MAnum: '392',
    pref: '兵庫県',
    MAName: '西宮',
    areaCode: '797',
    square: '399-354',
    head4digits: '0797',
  },
  {
    codeMain: '447',
    codeSub: '',
    MAnum: '393',
    pref: '兵庫県',
    MAName: '西宮',
    areaCode: '798',
    square: '399-354',
    head4digits: '0798',
  },
  {
    codeMain: '448',
    codeSub: '',
    MAnum: '394',
    pref: '兵庫県',
    MAName: '洲本',
    areaCode: '799',
    square: '377-333',
    head4digits: '0799',
  },
  {
    codeMain: '449',
    codeSub: '',
    MAnum: '395',
    pref: '兵庫県',
    MAName: '津名',
    areaCode: '799',
    square: '383-334',
    head4digits: '0799',
  },
  {
    codeMain: '450',
    codeSub: '',
    MAnum: '396',
    pref: '広島県',
    MAName: '広島',
    areaCode: '82',
    square: '381-221',
    head4digits: '0822',
  },
  {
    codeMain: '451',
    codeSub: '',
    MAnum: '397',
    pref: '山口県',
    MAName: '柳井',
    areaCode: '820',
    square: '357-203',
    head4digits: '0820',
  },
  {
    codeMain: '452',
    codeSub: '',
    MAnum: '398',
    pref: '山口県',
    MAName: '久賀',
    areaCode: '820',
    square: '356-210',
    head4digits: '0820',
  },
  {
    codeMain: '453',
    codeSub: '',
    MAnum: '399',
    pref: '広島県',
    MAName: '呉',
    areaCode: '823',
    square: '372-225',
    head4digits: '0823',
  },
  {
    codeMain: '454',
    codeSub: '',
    MAnum: '400',
    pref: '広島県',
    MAName: '三次',
    areaCode: '824',
    square: '403-241',
    head4digits: '0824',
  },
  {
    codeMain: '455',
    codeSub: '',
    MAnum: '401',
    pref: '広島県',
    MAName: '東広島',
    areaCode: '82',
    square: '382-234',
    head4digits: '0824',
  },
  {
    codeMain: '456',
    codeSub: '2',
    MAnum: '402',
    pref: '広島県',
    MAName: '庄原',
    areaCode: '824',
    square: '406-248',
    head4digits: '0824',
  },
  {
    codeMain: '461',
    codeSub: '',
    MAnum: '403',
    pref: '広島県',
    MAName: '千代田',
    areaCode: '826',
    square: '396-226',
    head4digits: '0826',
  },
  {
    codeMain: '462',
    codeSub: '',
    MAnum: '404',
    pref: '広島県',
    MAName: '安芸吉田',
    areaCode: '826',
    square: '395-234',
    head4digits: '0826',
  },
  {
    codeMain: '463',
    codeSub: '2',
    MAnum: '405',
    pref: '広島県',
    MAName: '加計',
    areaCode: '826',
    square: '392-216',
    head4digits: '0826',
  },
  {
    codeMain: '465',
    codeSub: '2',
    MAnum: '406',
    pref: '山口県',
    MAName: '岩国',
    areaCode: '827',
    square: '368-209',
    head4digits: '0827',
  },
  {
    codeMain: '467',
    codeSub: '',
    MAnum: '407',
    pref: '広島県',
    MAName: '廿日市',
    areaCode: '829',
    square: '378-216',
    head4digits: '0829',
  },
  {
    codeMain: '468',
    codeSub: '2',
    MAnum: '408',
    pref: '山口県',
    MAName: '下関',
    areaCode: '83',
    square: '356-149',
    head4digits: '0832',
  },
  {
    codeMain: '469',
    codeSub: '',
    MAnum: '409',
    pref: '山口県',
    MAName: '下松',
    areaCode: '833',
    square: '359-192',
    head4digits: '0833',
  },
  {
    codeMain: '470',
    codeSub: '',
    MAnum: '410',
    pref: '山口県',
    MAName: '徳山',
    areaCode: '834',
    square: '361-190',
    head4digits: '0834',
  },
  {
    codeMain: '471',
    codeSub: '',
    MAnum: '411',
    pref: '山口県',
    MAName: '防府',
    areaCode: '835',
    square: '361-179',
    head4digits: '0835',
  },
  {
    codeMain: '472',
    codeSub: '',
    MAnum: '412',
    pref: '山口県',
    MAName: '宇部',
    areaCode: '836',
    square: '356-163',
    head4digits: '0836',
  },
  {
    codeMain: '474',
    codeSub: '',
    MAnum: '413',
    pref: '山口県',
    MAName: '長門',
    areaCode: '837',
    square: '379-162',
    head4digits: '0837',
  },
  {
    codeMain: '475',
    codeSub: '2',
    MAnum: '414',
    pref: '山口県',
    MAName: '美祢',
    areaCode: '837',
    square: '368-162',
    head4digits: '0837',
  },
  {
    codeMain: '477',
    codeSub: '',
    MAnum: '415',
    pref: '山口県',
    MAName: '萩',
    areaCode: '838',
    square: '381-173',
    head4digits: '0838',
  },
  {
    codeMain: '478',
    codeSub: '',
    MAnum: '416',
    pref: '山口県',
    MAName: '田万川',
    areaCode: '8387',
    square: '394-185',
    head4digits: '0838',
  },
  {
    codeMain: '479',
    codeSub: '',
    MAnum: '417',
    pref: '山口県',
    MAName: '田万川',
    areaCode: '8388',
    square: '394-185',
    head4digits: '0838',
  },
  {
    codeMain: '481',
    codeSub: '3',
    MAnum: '418',
    pref: '山口県',
    MAName: '山口',
    areaCode: '83',
    square: '369-175',
    head4digits: '0839',
  },
  {
    codeMain: '483',
    codeSub: '',
    MAnum: '419',
    pref: '山口県',
    MAName: '山口',
    areaCode: '8396',
    square: '369-175',
    head4digits: '0839',
  },
  {
    codeMain: '485',
    codeSub: '',
    MAnum: '420',
    pref: '広島県',
    MAName: '因島',
    areaCode: '845',
    square: '374-254',
    head4digits: '0845',
  },
  {
    codeMain: '486',
    codeSub: '',
    MAnum: '421',
    pref: '広島県',
    MAName: '竹原',
    areaCode: '846',
    square: '378-242',
    head4digits: '0846',
  },
  {
    codeMain: '487',
    codeSub: '',
    MAnum: '422',
    pref: '広島県',
    MAName: '木江',
    areaCode: '846',
    square: '372-241',
    head4digits: '0846',
  },
  {
    codeMain: '488',
    codeSub: '2',
    MAnum: '423',
    pref: '広島県',
    MAName: '府中',
    areaCode: '847',
    square: '390-257',
    head4digits: '0847',
  },
  {
    codeMain: '489',
    codeSub: '3',
    MAnum: '424',
    pref: '広島県',
    MAName: '甲山',
    areaCode: '847',
    square: '391-249',
    head4digits: '0847',
  },
  {
    codeMain: '494',
    codeSub: '',
    MAnum: '425',
    pref: '広島県',
    MAName: '東城',
    areaCode: '8477',
    square: '408-260',
    head4digits: '0847',
  },
  {
    codeMain: '495',
    codeSub: '',
    MAnum: '426',
    pref: '広島県',
    MAName: '東城',
    areaCode: '847',
    square: '408-260',
    head4digits: '0847',
  },
  {
    codeMain: '496',
    codeSub: '2',
    MAnum: '427',
    pref: '広島県',
    MAName: '尾道☆',
    areaCode: '848',
    square: '381-254',
    head4digits: '0848',
  },
  {
    codeMain: '498',
    codeSub: '',
    MAnum: '428',
    pref: '広島県',
    MAName: '尾道☆',
    areaCode: '84',
    square: '381-254',
    head4digits: '0849',
  },
  {
    codeMain: '499',
    codeSub: '',
    MAnum: '429',
    pref: '広島県',
    MAName: '福山☆',
    areaCode: '84',
    square: '385-263',
    head4digits: '0849',
  },
  {
    codeMain: '500',
    codeSub: '',
    MAnum: '430',
    pref: '島根県',
    MAName: '西郷',
    areaCode: '8512',
    square: '481-268',
    head4digits: '0851',
  },
  {
    codeMain: '501',
    codeSub: '',
    MAnum: '431',
    pref: '島根県',
    MAName: '海士',
    areaCode: '8514',
    square: '475-256',
    head4digits: '0851',
  },
  {
    codeMain: '502',
    codeSub: '',
    MAnum: '432',
    pref: '島根県',
    MAName: '松江',
    areaCode: '852',
    square: '440-253',
    head4digits: '0852',
  },
  {
    codeMain: '503',
    codeSub: '',
    MAnum: '433',
    pref: '島根県',
    MAName: '出雲',
    areaCode: '853',
    square: '434-239',
    head4digits: '0853',
  },
  {
    codeMain: '504',
    codeSub: '',
    MAnum: '434',
    pref: '島根県',
    MAName: '安来',
    areaCode: '854',
    square: '438-262',
    head4digits: '0854',
  },
  {
    codeMain: '505',
    codeSub: '',
    MAnum: '435',
    pref: '島根県',
    MAName: '木次',
    areaCode: '854',
    square: '430-245',
    head4digits: '0854',
  },
  {
    codeMain: '506',
    codeSub: '',
    MAnum: '436',
    pref: '島根県',
    MAName: '掛合',
    areaCode: '854',
    square: '425-241',
    head4digits: '0854',
  },
  {
    codeMain: '507',
    codeSub: '',
    MAnum: '437',
    pref: '島根県',
    MAName: '石見大田',
    areaCode: '854',
    square: '425-226',
    head4digits: '0854',
  },
  {
    codeMain: '508',
    codeSub: '',
    MAnum: '438',
    pref: '島根県',
    MAName: '浜田',
    areaCode: '855',
    square: '408-206',
    head4digits: '0855',
  },
  {
    codeMain: '509',
    codeSub: '',
    MAnum: '439',
    pref: '島根県',
    MAName: '江津',
    areaCode: '855',
    square: '414-213',
    head4digits: '0855',
  },
  {
    codeMain: '510',
    codeSub: '',
    MAnum: '440',
    pref: '島根県',
    MAName: '川本',
    areaCode: '855',
    square: '413-225',
    head4digits: '0855',
  },
  {
    codeMain: '511',
    codeSub: '',
    MAnum: '441',
    pref: '島根県',
    MAName: '益田',
    areaCode: '856',
    square: '396-194',
    head4digits: '0856',
  },
  {
    codeMain: '512',
    codeSub: '',
    MAnum: '442',
    pref: '島根県',
    MAName: '津和野',
    areaCode: '856',
    square: '384-190',
    head4digits: '0856',
  },
  {
    codeMain: '513',
    codeSub: '',
    MAnum: '443',
    pref: '鳥取県',
    MAName: '鳥取',
    areaCode: '857',
    square: '442-306',
    head4digits: '0857',
  },
  {
    codeMain: '514',
    codeSub: '',
    MAnum: '444',
    pref: '鳥取県',
    MAName: '郡家',
    areaCode: '858',
    square: '437-307',
    head4digits: '0858',
  },
  {
    codeMain: '515',
    codeSub: '',
    MAnum: '445',
    pref: '鳥取県',
    MAName: '倉吉',
    areaCode: '858',
    square: '438-287',
    head4digits: '0858',
  },
  {
    codeMain: '516',
    codeSub: '',
    MAnum: '446',
    pref: '鳥取県',
    MAName: '米子',
    areaCode: '859',
    square: '438-265',
    head4digits: '0859',
  },
  {
    codeMain: '517',
    codeSub: '',
    MAnum: '447',
    pref: '鳥取県',
    MAName: '根雨',
    areaCode: '859',
    square: '427-269',
    head4digits: '0859',
  },
  {
    codeMain: '518',
    codeSub: '',
    MAnum: '448',
    pref: '岡山県',
    MAName: '倉敷',
    areaCode: '86',
    square: '392-282',
    head4digits: '0864',
  },
  {
    codeMain: '519',
    codeSub: '',
    MAnum: '449',
    pref: '岡山県',
    MAName: '岡山',
    areaCode: '86',
    square: '395-290',
    head4digits: '0862',
  },
  {
    codeMain: '520',
    codeSub: '',
    MAnum: '450',
    pref: '岡山県',
    MAName: '玉野',
    areaCode: '863',
    square: '386-289',
    head4digits: '0863',
  },
  {
    codeMain: '522',
    codeSub: '2',
    MAnum: '451',
    pref: '岡山県',
    MAName: '鴨方',
    areaCode: '865',
    square: '388-273',
    head4digits: '0865',
  },
  {
    codeMain: '525',
    codeSub: '',
    MAnum: '452',
    pref: '岡山県',
    MAName: '笠岡',
    areaCode: '865',
    square: '387-270',
    head4digits: '0865',
  },
  {
    codeMain: '526',
    codeSub: '',
    MAnum: '453',
    pref: '岡山県',
    MAName: '高梁',
    areaCode: '866',
    square: '403-276',
    head4digits: '0866',
  },
  {
    codeMain: '527',
    codeSub: '',
    MAnum: '454',
    pref: '岡山県',
    MAName: '井原',
    areaCode: '866',
    square: '392-268',
    head4digits: '0866',
  },
  {
    codeMain: '528',
    codeSub: '',
    MAnum: '455',
    pref: '岡山県',
    MAName: '総社',
    areaCode: '866',
    square: '396-281',
    head4digits: '0866',
  },
  {
    codeMain: '529',
    codeSub: '',
    MAnum: '457',
    pref: '岡山県',
    MAName: '新見',
    areaCode: '867',
    square: '413-269',
    head4digits: '0867',
  },
  {
    codeMain: '530',
    codeSub: '',
    MAnum: '458',
    pref: '岡山県',
    MAName: '久世',
    areaCode: '867',
    square: '418-283',
    head4digits: '0867',
  },
  {
    codeMain: '531',
    codeSub: '',
    MAnum: '456',
    pref: '岡山県',
    MAName: '加茂川',
    areaCode: '867',
    square: '408-285',
    head4digits: '0867',
  },
  {
    codeMain: '532',
    codeSub: '',
    MAnum: '459',
    pref: '岡山県',
    MAName: '津山',
    areaCode: '868',
    square: '417-294',
    head4digits: '0868',
  },
  {
    codeMain: '533',
    codeSub: '',
    MAnum: '460',
    pref: '岡山県',
    MAName: '美作',
    areaCode: '868',
    square: '414-301',
    head4digits: '0868',
  },
  {
    codeMain: '534',
    codeSub: '',
    MAnum: '461',
    pref: '岡山県',
    MAName: '備前',
    areaCode: '869',
    square: '400-301',
    head4digits: '0869',
  },
  {
    codeMain: '535',
    codeSub: '2',
    MAnum: '462',
    pref: '岡山県',
    MAName: '邑久',
    areaCode: '869',
    square: '395-297',
    head4digits: '0869',
  },
  {
    codeMain: '538',
    codeSub: '2',
    MAnum: '463',
    pref: '岡山県',
    MAName: '赤磐',
    areaCode: '86',
    square: '401-294',
    head4digits: '0869',
  },
  {
    codeMain: '540',
    codeSub: '',
    MAnum: '464',
    pref: '香川県',
    MAName: '観音寺',
    areaCode: '875',
    square: '365-275',
    head4digits: '0875',
  },
  {
    codeMain: '541',
    codeSub: '',
    MAnum: '465',
    pref: '香川県',
    MAName: '丸亀',
    areaCode: '877',
    square: '374-282',
    head4digits: '0877',
  },
  {
    codeMain: '542',
    codeSub: '',
    MAnum: '466',
    pref: '香川県',
    MAName: '高松',
    areaCode: '87',
    square: '377-294',
    head4digits: '0878',
  },
  {
    codeMain: '543',
    codeSub: '',
    MAnum: '467',
    pref: '香川県',
    MAName: '三本松',
    areaCode: '879',
    square: '372-307',
    head4digits: '0879',
  },
  {
    codeMain: '544',
    codeSub: '',
    MAnum: '468',
    pref: '香川県',
    MAName: '土庄',
    areaCode: '879',
    square: '385-301',
    head4digits: '0879',
  },
  {
    codeMain: '545',
    codeSub: '',
    MAnum: '469',
    pref: '高知県',
    MAName: '土佐中村',
    areaCode: '880',
    square: '303-238',
    head4digits: '0880',
  },
  {
    codeMain: '546',
    codeSub: '',
    MAnum: '470',
    pref: '高知県',
    MAName: '宿毛',
    areaCode: '880',
    square: '300-228',
    head4digits: '0880',
  },
  {
    codeMain: '547',
    codeSub: '2',
    MAnum: '471',
    pref: '高知県',
    MAName: '窪川',
    areaCode: '880',
    square: '315-248',
    head4digits: '0880',
  },
  {
    codeMain: '548',
    codeSub: '',
    MAnum: '472',
    pref: '高知県',
    MAName: '土佐清水',
    areaCode: '880',
    square: '291-238',
    head4digits: '0880',
  },
  {
    codeMain: '549',
    codeSub: '',
    MAnum: '473',
    pref: '徳島県',
    MAName: '鴨島',
    areaCode: '883',
    square: '362-308',
    head4digits: '0883',
  },
  {
    codeMain: '550',
    codeSub: '',
    MAnum: '474',
    pref: '徳島県',
    MAName: '脇町',
    areaCode: '883',
    square: '362-298',
    head4digits: '0883',
  },
  {
    codeMain: '551',
    codeSub: '',
    MAnum: '475',
    pref: '徳島県',
    MAName: '阿波池田',
    areaCode: '883',
    square: '360-282',
    head4digits: '0883',
  },
  {
    codeMain: '552',
    codeSub: '',
    MAnum: '476',
    pref: '徳島県',
    MAName: '阿南',
    areaCode: '884',
    square: '354-321',
    head4digits: '0884',
  },
  {
    codeMain: '553',
    codeSub: '',
    MAnum: '477',
    pref: '徳島県',
    MAName: '丹生谷',
    areaCode: '884',
    square: '351-313',
    head4digits: '0884',
  },
  {
    codeMain: '554',
    codeSub: '2',
    MAnum: '478',
    pref: '徳島県',
    MAName: '牟岐',
    areaCode: '884',
    square: '340-309',
    head4digits: '0884',
  },
  {
    codeMain: '555',
    codeSub: '2',
    MAnum: '479',
    pref: '徳島県',
    MAName: '小松島',
    areaCode: '885',
    square: '359-318',
    head4digits: '0885',
  },
  {
    codeMain: '557',
    codeSub: '2',
    MAnum: '480',
    pref: '徳島県',
    MAName: '徳島',
    areaCode: '88',
    square: '362-316',
    head4digits: '0886',
  },
  {
    codeMain: '558',
    codeSub: '',
    MAnum: '481',
    pref: '高知県',
    MAName: '嶺北',
    areaCode: '887',
    square: '346-274',
    head4digits: '0887',
  },
  {
    codeMain: '559',
    codeSub: '2',
    MAnum: '482',
    pref: '高知県',
    MAName: '室戸',
    areaCode: '887',
    square: '319-296',
    head4digits: '0887',
  },
  {
    codeMain: '560',
    codeSub: '3',
    MAnum: '483',
    pref: '高知県',
    MAName: '安芸',
    areaCode: '887',
    square: '331-285',
    head4digits: '0887',
  },
  {
    codeMain: '562',
    codeSub: '2',
    MAnum: '484',
    pref: '高知県',
    MAName: '土佐山田',
    areaCode: '887',
    square: '337-275',
    head4digits: '0887',
  },
  {
    codeMain: '563',
    codeSub: '2',
    MAnum: '485',
    pref: '高知県',
    MAName: '高知',
    areaCode: '88',
    square: '334-268',
    head4digits: '0888',
  },
  {
    codeMain: '564',
    codeSub: '',
    MAnum: '486',
    pref: '高知県',
    MAName: '佐川',
    areaCode: '889',
    square: '331-256',
    head4digits: '0889',
  },
  {
    codeMain: '565',
    codeSub: '',
    MAnum: '487',
    pref: '高知県',
    MAName: '須崎',
    areaCode: '889',
    square: '325-256',
    head4digits: '0889',
  },
  {
    codeMain: '566',
    codeSub: '',
    MAnum: '488',
    pref: '愛媛県',
    MAName: '久万',
    areaCode: '892',
    square: '339-239',
    head4digits: '0892',
  },
  {
    codeMain: '567',
    codeSub: '',
    MAnum: '489',
    pref: '愛媛県',
    MAName: '大洲',
    areaCode: '893',
    square: '331-222',
    head4digits: '0893',
  },
  {
    codeMain: '568',
    codeSub: '',
    MAnum: '490',
    pref: '愛媛県',
    MAName: '八幡浜',
    areaCode: '894',
    square: '329-216',
    head4digits: '0894',
  },
  {
    codeMain: '569',
    codeSub: '',
    MAnum: '491',
    pref: '愛媛県',
    MAName: '宇和',
    areaCode: '894',
    square: '323-220',
    head4digits: '0894',
  },
  {
    codeMain: '570',
    codeSub: '',
    MAnum: '492',
    pref: '愛媛県',
    MAName: '宇和島',
    areaCode: '895',
    square: '316-222',
    head4digits: '0895',
  },
  {
    codeMain: '571',
    codeSub: '',
    MAnum: '493',
    pref: '愛媛県',
    MAName: '御荘',
    areaCode: '895',
    square: '301-221',
    head4digits: '0895',
  },
  {
    codeMain: '572',
    codeSub: '',
    MAnum: '494',
    pref: '愛媛県',
    MAName: '伊予三島',
    areaCode: '896',
    square: '357-270',
    head4digits: '0896',
  },
  {
    codeMain: '573',
    codeSub: '',
    MAnum: '495',
    pref: '愛媛県',
    MAName: '伯方',
    areaCode: '897',
    square: '370-251',
    head4digits: '0897',
  },
  {
    codeMain: '574',
    codeSub: '',
    MAnum: '496',
    pref: '愛媛県',
    MAName: '新居浜',
    areaCode: '897',
    square: '356-257',
    head4digits: '0897',
  },
  {
    codeMain: '575',
    codeSub: '',
    MAnum: '497',
    pref: '愛媛県',
    MAName: '今治',
    areaCode: '898',
    square: '362-245',
    head4digits: '0898',
  },
  {
    codeMain: '576',
    codeSub: '',
    MAnum: '498',
    pref: '愛媛県',
    MAName: '松山',
    areaCode: '89',
    square: '350-233',
    head4digits: '0899',
  },
  {
    codeMain: '577',
    codeSub: '',
    MAnum: '499',
    pref: '福岡県',
    MAName: '前原',
    areaCode: '92',
    square: '334-113',
    head4digits: '0923',
  },
  {
    codeMain: '578',
    codeSub: '',
    MAnum: '500',
    pref: '福岡県',
    MAName: '福岡',
    areaCode: '92',
    square: '336-123',
    head4digits: '0922',
  },
  {
    codeMain: '579',
    codeSub: '',
    MAnum: '501',
    pref: '長崎県',
    MAName: '郷ノ浦',
    areaCode: '920',
    square: '345-090',
    head4digits: '0920',
  },
  {
    codeMain: '580',
    codeSub: '',
    MAnum: '502',
    pref: '長崎県',
    MAName: '厳原',
    areaCode: '920',
    square: '370-074',
    head4digits: '0920',
  },
  {
    codeMain: '581',
    codeSub: '',
    MAnum: '503',
    pref: '長崎県',
    MAName: '対馬佐賀',
    areaCode: '920',
    square: '384-080',
    head4digits: '0920',
  },
  {
    codeMain: '582',
    codeSub: '',
    MAnum: '504',
    pref: '福岡県',
    MAName: '北九州',
    areaCode: '93',
    square: '352-146',
    head4digits: '0932',
  },
  {
    codeMain: '583',
    codeSub: '',
    MAnum: '505',
    pref: '福岡県',
    MAName: '行橋',
    areaCode: '930',
    square: '344-150',
    head4digits: '0930',
  },
  {
    codeMain: '584',
    codeSub: '',
    MAnum: '506',
    pref: '福岡県',
    MAName: '宗像',
    areaCode: '940',
    square: '348-130',
    head4digits: '0940',
  },
  {
    codeMain: '585',
    codeSub: '',
    MAnum: '507',
    pref: '福岡県',
    MAName: '久留米',
    areaCode: '942',
    square: '321-126',
    head4digits: '0942',
  },
  {
    codeMain: '586',
    codeSub: '',
    MAnum: '508',
    pref: '福岡県',
    MAName: '八女',
    areaCode: '943',
    square: '315-128',
    head4digits: '0943',
  },
  {
    codeMain: '587',
    codeSub: '',
    MAnum: '509',
    pref: '福岡県',
    MAName: '田主丸',
    areaCode: '943',
    square: '322-135',
    head4digits: '0943',
  },
  {
    codeMain: '588',
    codeSub: '',
    MAnum: '510',
    pref: '福岡県',
    MAName: '瀬高',
    areaCode: '944',
    square: '311-124',
    head4digits: '0944',
  },
  {
    codeMain: '589',
    codeSub: '',
    MAnum: '511',
    pref: '福岡県',
    MAName: '甘木',
    areaCode: '946',
    square: '327-134',
    head4digits: '0946',
  },
  {
    codeMain: '590',
    codeSub: '',
    MAnum: '512',
    pref: '福岡県',
    MAName: '田川',
    areaCode: '947',
    square: '339-141',
    head4digits: '0947',
  },
  {
    codeMain: '591',
    codeSub: '',
    MAnum: '513',
    pref: '福岡県',
    MAName: '飯塚',
    areaCode: '948',
    square: '338-136',
    head4digits: '0948',
  },
  {
    codeMain: '592',
    codeSub: '',
    MAnum: '514',
    pref: '福岡県',
    MAName: '直方',
    areaCode: '949',
    square: '344-138',
    head4digits: '0949',
  },
  {
    codeMain: '593',
    codeSub: '',
    MAnum: '514',
    pref: '福岡県',
    MAName: '直方',
    areaCode: '949',
    square: '344-138',
    head4digits: '0949',
  },
  {
    codeMain: '594',
    codeSub: '',
    MAnum: '515',
    pref: '長崎県',
    MAName: '平戸',
    areaCode: '950',
    square: '324-082',
    head4digits: '0950',
  },
  {
    codeMain: '595',
    codeSub: '',
    MAnum: '516',
    pref: '佐賀県',
    MAName: '佐賀',
    areaCode: '952',
    square: '317-116',
    head4digits: '0952',
  },
  {
    codeMain: '596',
    codeSub: '',
    MAnum: '517',
    pref: '佐賀県',
    MAName: '武雄',
    areaCode: '954',
    square: '314-103',
    head4digits: '0954',
  },
  {
    codeMain: '597',
    codeSub: '',
    MAnum: '518',
    pref: '佐賀県',
    MAName: '鹿島',
    areaCode: '954',
    square: '309-106',
    head4digits: '0954',
  },
  {
    codeMain: '598',
    codeSub: '',
    MAnum: '519',
    pref: '佐賀県',
    MAName: '唐津',
    areaCode: '955',
    square: '328-102',
    head4digits: '0955',
  },
  {
    codeMain: '599',
    codeSub: '',
    MAnum: '520',
    pref: '佐賀県',
    MAName: '伊万里',
    areaCode: '955',
    square: '318-097',
    head4digits: '0955',
  },
  {
    codeMain: '600',
    codeSub: '',
    MAnum: '521',
    pref: '長崎県',
    MAName: '佐世保',
    areaCode: '956',
    square: '313-088',
    head4digits: '0956',
  },
  {
    codeMain: '601',
    codeSub: '',
    MAnum: '522',
    pref: '長崎県',
    MAName: '諫早',
    areaCode: '957',
    square: '295-102',
    head4digits: '0957',
  },
  {
    codeMain: '602',
    codeSub: '',
    MAnum: '523',
    pref: '長崎県',
    MAName: '島原',
    areaCode: '957',
    square: '291-117',
    head4digits: '0957',
  },
  {
    codeMain: '603',
    codeSub: '',
    MAnum: '524',
    pref: '長崎県',
    MAName: '長崎',
    areaCode: '95',
    square: '289-094',
    head4digits: '0958',
  },
  {
    codeMain: '604',
    codeSub: '',
    MAnum: '525',
    pref: '長崎県',
    MAName: '大瀬戸',
    areaCode: '959',
    square: '299-084',
    head4digits: '0959',
  },
  {
    codeMain: '605',
    codeSub: '',
    MAnum: '526',
    pref: '長崎県',
    MAName: '福江',
    areaCode: '959',
    square: '286-045',
    head4digits: '0959',
  },
  {
    codeMain: '606',
    codeSub: '',
    MAnum: '527',
    pref: '長崎県',
    MAName: '有川',
    areaCode: '959',
    square: '302-060',
    head4digits: '0959',
  },
  {
    codeMain: '607',
    codeSub: '',
    MAnum: '528',
    pref: '熊本県',
    MAName: '熊本',
    areaCode: '96',
    square: '292-133',
    head4digits: '0962',
  },
  {
    codeMain: '608',
    codeSub: '',
    MAnum: '529',
    pref: '熊本県',
    MAName: '松橋',
    areaCode: '964',
    square: '284-131',
    head4digits: '0964',
  },
  {
    codeMain: '609',
    codeSub: '',
    MAnum: '530',
    pref: '熊本県',
    MAName: '八代',
    areaCode: '965',
    square: '276-127',
    head4digits: '0965',
  },
  {
    codeMain: '610',
    codeSub: '',
    MAnum: '531',
    pref: '熊本県',
    MAName: '人吉',
    areaCode: '966',
    square: '260-133',
    head4digits: '0966',
  },
  {
    codeMain: '611',
    codeSub: '',
    MAnum: '532',
    pref: '熊本県',
    MAName: '水俣',
    areaCode: '966',
    square: '259-116',
    head4digits: '0966',
  },
  {
    codeMain: '612',
    codeSub: '',
    MAnum: '533',
    pref: '熊本県',
    MAName: '熊本一の宮',
    areaCode: '967',
    square: '300-152',
    head4digits: '0967',
  },
  {
    codeMain: '613',
    codeSub: '',
    MAnum: '534',
    pref: '熊本県',
    MAName: '矢部',
    areaCode: '967',
    square: '286-145',
    head4digits: '0967',
  },
  {
    codeMain: '614',
    codeSub: '',
    MAnum: '535',
    pref: '熊本県',
    MAName: '高森',
    areaCode: '967',
    square: '293-153',
    head4digits: '0967',
  },
  {
    codeMain: '615',
    codeSub: '',
    MAnum: '536',
    pref: '熊本県',
    MAName: '山鹿',
    areaCode: '968',
    square: '304-133',
    head4digits: '0968',
  },
  {
    codeMain: '616',
    codeSub: '',
    MAnum: '537',
    pref: '熊本県',
    MAName: '玉名',
    areaCode: '968',
    square: '299-127',
    head4digits: '0968',
  },
  {
    codeMain: '617',
    codeSub: '2',
    MAnum: '538',
    pref: '熊本県',
    MAName: '天草',
    areaCode: '969',
    square: '273-107',
    head4digits: '0969',
  },
  {
    codeMain: '619',
    codeSub: '',
    MAnum: '539',
    pref: '大分県',
    MAName: '佐伯',
    areaCode: '972',
    square: '301-189',
    head4digits: '0972',
  },
  {
    codeMain: '620',
    codeSub: '',
    MAnum: '540',
    pref: '大分県',
    MAName: '臼杵',
    areaCode: '972',
    square: '310-185',
    head4digits: '0972',
  },
  {
    codeMain: '621',
    codeSub: '',
    MAnum: '541',
    pref: '大分県',
    MAName: '日田',
    areaCode: '973',
    square: '321-146',
    head4digits: '0973',
  },
  {
    codeMain: '622',
    codeSub: '',
    MAnum: '542',
    pref: '大分県',
    MAName: '玖珠',
    areaCode: '973',
    square: '319-156',
    head4digits: '0973',
  },
  {
    codeMain: '623',
    codeSub: '',
    MAnum: '543',
    pref: '大分県',
    MAName: '三重',
    areaCode: '974',
    square: '302-174',
    head4digits: '0974',
  },
  {
    codeMain: '624',
    codeSub: '',
    MAnum: '544',
    pref: '大分県',
    MAName: '竹田',
    areaCode: '974',
    square: '301-166',
    head4digits: '0974',
  },
  {
    codeMain: '625',
    codeSub: '',
    MAnum: '545',
    pref: '大分県',
    MAName: '大分',
    areaCode: '97',
    square: '316-177',
    head4digits: '0975',
  },
  {
    codeMain: '626',
    codeSub: '',
    MAnum: '546',
    pref: '大分県',
    MAName: '別府',
    areaCode: '977',
    square: '318-172',
    head4digits: '0977',
  },
  {
    codeMain: '627',
    codeSub: '',
    MAnum: '547',
    pref: '大分県',
    MAName: '国東',
    areaCode: '978',
    square: '334-184',
    head4digits: '0978',
  },
  {
    codeMain: '628',
    codeSub: '',
    MAnum: '548',
    pref: '大分県',
    MAName: '豊後高田',
    areaCode: '978',
    square: '334-170',
    head4digits: '0978',
  },
  {
    codeMain: '629',
    codeSub: '',
    MAnum: '549',
    pref: '大分県',
    MAName: '杵築',
    areaCode: '978',
    square: '326-178',
    head4digits: '0978',
  },
  {
    codeMain: '630',
    codeSub: '',
    MAnum: '550',
    pref: '大分県',
    MAName: '中津',
    areaCode: '979',
    square: '337-159',
    head4digits: '0979',
  },
  {
    codeMain: '631',
    codeSub: '',
    MAnum: '551',
    pref: '沖縄県',
    MAName: '那覇',
    areaCode: '98',
    square: '(-073)-(-046)',
    head4digits: '0988',
  },
  {
    codeMain: '632',
    codeSub: '',
    MAnum: '552',
    pref: '沖縄県',
    MAName: '名護',
    areaCode: '980',
    square: '(-052)-(-032)',
    head4digits: '0980',
  },
  {
    codeMain: '633',
    codeSub: '',
    MAnum: '553',
    pref: '沖縄県',
    MAName: '南大東',
    areaCode: '9802',
    square: '(-094)-131',
    head4digits: '0980',
  },
  {
    codeMain: '634',
    codeSub: '',
    MAnum: '554',
    pref: '沖縄県',
    MAName: '沖縄宮古',
    areaCode: '980',
    square: '(-151)-(-168)',
    head4digits: '0980',
  },
  {
    codeMain: '635',
    codeSub: '',
    MAnum: '555',
    pref: '沖縄県',
    MAName: '八重山',
    areaCode: '980',
    square: '(-177)-(-227)',
    head4digits: '0980',
  },
  {
    codeMain: '636',
    codeSub: '',
    MAnum: '556',
    pref: '宮崎県',
    MAName: '延岡',
    areaCode: '982',
    square: '280-177',
    head4digits: '0982',
  },
  {
    codeMain: '637',
    codeSub: '',
    MAnum: '557',
    pref: '宮崎県',
    MAName: '日向',
    areaCode: '982',
    square: '271-175',
    head4digits: '0982',
  },
  {
    codeMain: '638',
    codeSub: '',
    MAnum: '558',
    pref: '宮崎県',
    MAName: '高千穂',
    areaCode: '982',
    square: '287-161',
    head4digits: '0982',
  },
  {
    codeMain: '639',
    codeSub: '',
    MAnum: '559',
    pref: '宮崎県',
    MAName: '高鍋',
    areaCode: '983',
    square: '255-168',
    head4digits: '0983',
  },
  {
    codeMain: '640',
    codeSub: '',
    MAnum: '560',
    pref: '宮崎県',
    MAName: '小林',
    areaCode: '984',
    square: '247-142',
    head4digits: '0984',
  },
  {
    codeMain: '641',
    codeSub: '',
    MAnum: '561',
    pref: '宮崎県',
    MAName: '宮崎',
    areaCode: '985',
    square: '243-163',
    head4digits: '0985',
  },
  {
    codeMain: '642',
    codeSub: '',
    MAnum: '562',
    pref: '宮崎県',
    MAName: '都城',
    areaCode: '986',
    square: '232-145',
    head4digits: '0986',
  },
  {
    codeMain: '643',
    codeSub: '',
    MAnum: '563',
    pref: '宮崎県',
    MAName: '日南',
    areaCode: '987',
    square: '225-160',
    head4digits: '0987',
  },
  {
    codeMain: '644',
    codeSub: '',
    MAnum: '564',
    pref: '鹿児島県',
    MAName: '中之島',
    areaCode: '9912',
    square: '129-079',
    head4digits: '0991',
  },
  {
    codeMain: '645',
    codeSub: '',
    MAnum: '565',
    pref: '鹿児島県',
    MAName: '硫黄島',
    areaCode: '9913',
    square: '180-103',
    head4digits: '0991',
  },
  {
    codeMain: '646',
    codeSub: '',
    MAnum: '566',
    pref: '鹿児島県',
    MAName: '鹿児島',
    areaCode: '99',
    square: '225-120',
    head4digits: '0992',
  },
  {
    codeMain: '647',
    codeSub: '',
    MAnum: '567',
    pref: '鹿児島県',
    MAName: '指宿',
    areaCode: '993',
    square: '206-123',
    head4digits: '0993',
  },
  {
    codeMain: '648',
    codeSub: '',
    MAnum: '568',
    pref: '鹿児島県',
    MAName: '加世田',
    areaCode: '993',
    square: '215-108',
    head4digits: '0993',
  },
  {
    codeMain: '649',
    codeSub: '',
    MAnum: '569',
    pref: '鹿児島県',
    MAName: '志布志',
    areaCode: '99',
    square: '219-145',
    head4digits: '0994',
  },
  {
    codeMain: '650',
    codeSub: '',
    MAnum: '570',
    pref: '鹿児島県',
    MAName: '鹿屋',
    areaCode: '994',
    square: '214-133',
    head4digits: '0994',
  },
  {
    codeMain: '651',
    codeSub: '',
    MAnum: '571',
    pref: '鹿児島県',
    MAName: '大根占',
    areaCode: '994',
    square: '206-129',
    head4digits: '0994',
  },
  {
    codeMain: '652',
    codeSub: '',
    MAnum: '572',
    pref: '鹿児島県',
    MAName: '加治木',
    areaCode: '995',
    square: '233-126',
    head4digits: '0995',
  },
  {
    codeMain: '653',
    codeSub: '',
    MAnum: '573',
    pref: '鹿児島県',
    MAName: '大口',
    areaCode: '995',
    square: '251-125',
    head4digits: '0995',
  },
  {
    codeMain: '654',
    codeSub: '',
    MAnum: '574',
    pref: '鹿児島県',
    MAName: '出水',
    areaCode: '996',
    square: '252-113',
    head4digits: '0996',
  },
  {
    codeMain: '655',
    codeSub: '',
    MAnum: '575',
    pref: '鹿児島県',
    MAName: '川内',
    areaCode: '996',
    square: '237-109',
    head4digits: '0996',
  },
  {
    codeMain: '656',
    codeSub: '',
    MAnum: '576',
    pref: '鹿児島県',
    MAName: '中甑',
    areaCode: '9969',
    square: '239-089',
    head4digits: '0996',
  },
  {
    codeMain: '657',
    codeSub: '',
    MAnum: '577',
    pref: '鹿児島県',
    MAName: '名瀬',
    areaCode: '997',
    square: '047-054',
    head4digits: '0997',
  },
  {
    codeMain: '658',
    codeSub: '',
    MAnum: '578',
    pref: '鹿児島県',
    MAName: '徳之島',
    areaCode: '997',
    square: '011-027',
    head4digits: '0997',
  },
  {
    codeMain: '659',
    codeSub: '',
    MAnum: '579',
    pref: '鹿児島県',
    MAName: '種子島',
    areaCode: '997',
    square: '177-137',
    head4digits: '0997',
  },
  {
    codeMain: '660',
    codeSub: '',
    MAnum: '580',
    pref: '鹿児島県',
    MAName: '屋久島',
    areaCode: '997',
    square: '160-116',
    head4digits: '0997',
  },
  {
    codeMain: '661',
    codeSub: '',
    MAnum: '581',
    pref: '鹿児島県',
    MAName: '瀬戸内',
    areaCode: '997',
    square: '034-044',
    head4digits: '0997',
  },
]

export default MACompList
